import { PureComponent } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { AutoActionIntent, IGameplayEvent, IJoinedRoomState } from '../../Core/State/IJoinedRoomState';
import SwitchToLobbyIcon from '@mui/icons-material/MeetingRoom';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import LeaveRoomIcon from '@mui/icons-material/ExitToApp';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import MenuIcon from '@mui/icons-material/Menu';
import { IUserState } from '../../Core/State/IUserState';
import React from 'react';
import CardImage from './SubComponents/Card';
import { IPlayerState } from '../../Core/State/IPlayerState';
import { getMuted, getVolume, playAudio, setMuted, setVolume } from '../../Utils/AudioUtils';
import WinnersDisplay from './SubComponents/WinnersDisplay';
import PokerTable, { CardAnimationStyle } from './SubComponents/PokerTable';
import { ThemeProvider } from '@mui/material/styles';
import { PokerTheme, classicTheme, modernTheme, luxuryTheme, westernTheme, spaceTheme } from '../../Themes/PokerThemes';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from '../../assets/css/components/Aof.module.css';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, Stack, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, CircularProgress, Menu, MenuItem } from '@mui/material';
import { useSnackbar } from 'notistack';
import { NotificationTemplateUtil } from '../../Utils/NotificationTemplateUtil.tsx';
import stakesChipIcon from '/images/table/chip.svg';
import sitHereIcon from '/images/table/sit-here.svg';
import emptyIcon from '/images/table/empty.svg';
import BuyinModal from './SubComponents/BuyinModal';
import { debounce } from 'lodash';
import { isMobile } from 'react-device-detect';
import GameInfo, { GameInfoTurnHistoryEntry } from './SubComponents/GameInfo';
import TurnActionControls from './SubComponents/TurnActionControls';
import PlayerSlot from './SubComponents/PlayerSlot';
import { DebugPanel } from './SubComponents/DebugPanel';
import Link from '@mui/material/Link';
import WinInformation from './SubComponents/WinInformation';
import WinTournamentModal from './SubComponents/WinTournamentModal';
import { PlayerCardAnimationStyle } from './SubComponents/PlayerSlot';
import ShowCardsOptions from './SubComponents/ShowCardOptions';
import TopUpOptionsComponent from './SubComponents/TopUpOptionsComponent';
import SitOutOptionsComponent from './SubComponents/SitOutOptionsComponent';
import AutoActionOptionsComponent from './SubComponents/AutoActionOptionsComponent';
import StatusBar, { TableReactionStatus } from './SubComponents/StatusBar';
import crashxIcon from '/images/table/crashx.png';
import blackjackIcon from '/images/table/blackjack.png';
import rouletteIcon from '/images/table/roulette.png';
import baccaratIcon from '/images/table/baccarat.png';
import { Pause, EventSeat, Apps, Info as InfoIcon, Settings, Check, VolumeOff, VolumeUp, Visibility, VisibilityOff } from '@mui/icons-material';
import fundsChipIcon from '/images/table/chip-alt.svg';
import { ActivityMessage } from '../../Utils/TemplateUtil';
import { getTexasPresetBasePot } from '../../Utils/PokerPotUtils';
import { DetachedWindowContext } from './WindowPortal';
import ReactDOM from 'react-dom';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TournamentExtraInfo from './SubComponents/TournamentExtraInfo';
import { CurrencyDecimals } from '../../Utils/CurrencyDecimals';
import DetachedTournamentLobby from '../Lobby/Tournament/Lobby/DetachedTournamentLobby';
import DesktopTournamentLobbyModal from '../Lobby/Tournament/Lobby/DesktopTournamentLobbyModal';
import TournamentLobbyContent from '../Lobby/Tournament/Lobby/TournamentLobbyContent';
import { InteractionHandler } from '../../Core/Handler/InteractionHandler';
import { ITournamentState } from '../../Core/State/ILobbyTournamentState';
import { t } from '../../i18n';
import {
    GameRoomPresentationState,
    PokerPlayerPresentationApplier
} from './Presentation/PokerPlayerPresentation';
import {
    HAND_PRESENTATION_FADE_OUT_MS,
    isGameplayAudioPlaybackAllowed,
    shouldShowPlayerCardsForRoomState
} from './Presentation/PokerPresentationConfig';
import { PokerPresentation } from './Presentation/PokerPresentation';
import {
    PokerAudioPresetId,
    PokerAudioPresetManager
} from './Presentation/PokerAudioPresetManager';
import { roomGameplayEventBus } from '../../Core/Events/RoomGameplayEventBus';
import { roomTableReactionEventBus } from '../../Core/Events/RoomTableReactionEventBus';
import { ITableReactionEvent, TableReactionId } from '../../Core/State/ITableReactionState';
import {
    ActivePokerTableReaction,
    PokerTableReactionLayer,
    POKER_TABLE_REACTION_LIFETIME_MS,
    POKER_TABLE_REACTION_SEND_COOLDOWN_MS,
    getPokerTableReaction,
    PokerTableReactionPicker,
    PokerTableReactionPoint
} from './SubComponents/PokerTableReactions';
import { POKER_TABLE_DESKTOP_SURFACE_LAYOUT } from './Presentation/PokerTableResponsiveScale';

interface RoomProps {
    leaveRoom: (roomId: string) => void;
    sitOnRoom: (roomId: string, seatIndex: number, amount: number) => void;
    standFromRoom: (roomId: string) => void;
    switchToLobby: () => void;
    roomState: IJoinedRoomState;
    userState: IUserState;
    requestRoomState: (roomId: string) => void;
    sendAction: (roomId: string, action: string, amount: number, userId: string) => void;
    isUserSeated: boolean;
    isSingleRoomView: boolean;
    theme?: 'modern' | 'classic' | 'luxury' | 'western' | 'space';
    sendBalanceUpdate: (roomId: string, userId: string, balance: number) => void;
    requestSitOptions: (roomId: string, seatIndex: number) => void;
    requestSit: (roomId: string, seatIndex: number, buyInAmount: number, postOrWaitChoice?: 'post' | 'wait') => void;
    updateRoomState: (data: { roomId: string; state: Partial<IJoinedRoomState>; }) => void;
    requestShowCardsOption: (roomId: string, cards: string[]) => void;
    requestBalanceOptions: (roomId: string, userId: string) => void;
    requestTopUpNextHand: (roomId: string) => void;
    requestTopUpAlways: (roomId: string) => void;
    requestCancelTopUp: (roomId: string) => void;
    requestSitOutNextHand: (roomId: string) => void;
    requestCancelSitOutNextHand: (roomId: string) => void;
    requestSitOutNextBb: (roomId: string) => void;
    requestCancelSitOutNextBb: (roomId: string) => void;
    requestSetAutoAction: (roomId: string, intent: AutoActionIntent, maxCallAmount?: number) => void;
    requestCancelAutoAction: (roomId: string) => void;
    requestSendTableReaction: (roomId: string, targetUserId: string, reactionId: TableReactionId) => void;
    requestSitBackIn?: (roomId: string) => void;
    isDetached?: boolean;
    confirmLeaveRoom?: () => void;
    onShowNotification?: (message: string, variant?: 'success' | 'error' | 'info' | 'warning') => void;
}

type SelectedAutoAction = {
    type: AutoActionIntent;
};

type PokerTableReactionTarget = {
    userId: string;
    username: string;
    anchorEl: HTMLElement;
};

interface RoomState extends GameRoomPresentationState {
    buyInAmount: number;
    showSitFailedNoMoneyAlert: boolean;
    isCurrentUserSeatedAnywhere: boolean;
    betAmount: number;
    animatingChips: { id: string, startPos: { x: number, y: number }, endPos: { x: number, y: number } }[];
    showAnimatedChip: boolean;
    isAnimating: boolean;
    animationQueue: number[];
    balanceChanges: { [key: string]: number };
    isPinned: boolean;
    lastWinners: any[] | null;
    lastNonWinners: any[] | null;
    lastCommunityCards: string[] | null;
    lastPlayerTurnHistory: {
        time: string;
        username: string;
        userId: string;
        roundName: string;
        availableActions: Array<{
            type: string;
            minAmount: number;
            maxAmount: number;
        }>;
        pot: number;
        communityCards: string[];
        playerCurrentBets: { userId: string; amount: number; username: string; }[];
        playerBalances: { userId: string; amount: number; username: string; }[];
        playerCards: { userId: string; cards: string[]; username: string; }[];
        smallBlindId: string;
        bigBlindId: string;
        smallBlindUsername: string;
        bigBlindUsername: string;
        dealerId: string;
        dealerUsername: string;
        selectedAction: {
            action: string;
            amount: number;
        };
    }[];
    pinnedWinners: any[] | null;
    pinnedCommunityCards: string[] | null;
    pinnedPlayers: IPlayerState[];
    pinnedPlayerTurnHistory: any[];
    pinnedNonWinners: any[] | null;
    pinnedGameId: string | null;
    currentTheme: PokerTheme;
    activePlayerTimer: number | null;
    prevTurnStartTime: string | null;
    showBalanceAddSlider: boolean;
    balanceAddAmount: number;
    hideActions: boolean;
    tempInputValue: string;
    showDebugPanel: boolean;
    isDebugPaused: boolean;
    availableActions: {
        userId: string;
        actions: Array<{
            type: string;
            minAmount: number;
            maxAmount: number;
        }>;
    } | null;
    showWinModal: boolean;
    ante: number;
    selectedAutoAction: SelectedAutoAction | null;
    pendingBalanceUpdates: any;
    showTopUpOptions: boolean;
    topUpNextHandPlayers: Set<string>;
    topUpAllHandsPlayers: Set<string>;
    willSitOutNextHandPlayers: Set<string>;
    playerEquities: any;
    isGameInfoExpanded: boolean;
    isMobileDrawerExpanded: boolean;
    hideCurrentBetChipsThisHand: boolean;
    copySuccess: string | null;
    showTournamentExtraInfo: boolean;
    showFullGameId: boolean;
    tournamentLobbyModalOpen: boolean;
    modalTournamentId: string | null;
    selectedAudioPresetId: PokerAudioPresetId;
    audioPresetMenuAnchorEl: HTMLElement | null;
    isAudioMuted: boolean;
    audioVolumeBeforeMute: number | null;
    gameplayActivityMessages: ActivityMessage[];
    gameplayTurnHistory: GameInfoTurnHistoryEntry[];
    tableReactionPickerTarget: PokerTableReactionTarget | null;
    activeTableReactions: ActivePokerTableReaction[];
    showTableReactions: boolean;
    tableReactionCooldownUntil: number | null;
    tableReactionCooldownSecondsRemaining: number;
    tableReactionStatus: TableReactionStatus | null;
}

let ACTIVE_GAME_ROUNDS: any[] = [];

const TEXAS_TABLE_SEAT_COUNT = 6;
const AOF_TABLE_SEAT_COUNT = 3;

interface GameRoomInternalProps extends RoomProps {
    roomEnqueueSnackbar?: (message: any, options?: any) => void;
    roomCloseSnackbar?: (key: any) => void;
}

const memoizeOne = <F extends (...args: any[]) => any>(fn: F): F => {
    let lastArgs: any[] | null = null;
    let lastResult: any;
    return ((...args: any[]) => {
        if (lastArgs &&
            lastArgs.length === args.length &&
            lastArgs.every((arg, index) => arg === args[index])) {
            return lastResult;
        }
        lastArgs = args;
        lastResult = fn(...args);
        return lastResult;
    }) as F;
};

class GameRoomInner extends PureComponent<GameRoomInternalProps, RoomState> {
    private memoizedPlayerTurnHistory: IJoinedRoomState['playerTurnHistory'] = [];
    private presentationStateApplier: PokerPlayerPresentationApplier<SelectedAutoAction>;
    private readonly audioPresetManager = new PokerAudioPresetManager();
    private pokerPresentation: PokerPresentation;
    private unsubscribeGameplayEvents: (() => void) | null = null;
    private unsubscribeTableReactionEvents: (() => void) | null = null;
    private handledTableReactionIds: Set<string> = new Set();
    private handledTableReactionIdOrder: string[] = [];
    private tableReactionTimers: NodeJS.Timeout[] = [];
    private tableReactionCooldownTimer: NodeJS.Timeout | null = null;
    private tableReactionStatusTimer: NodeJS.Timeout | null = null;
    private completedHandPresentationFadeOutTimer: NodeJS.Timeout | null = null;
    private getPlayerInfoMemo = memoizeOne((players: IPlayerState[], userId: string, activePlayerId: string | null) => {
        const currentPlayer = players.find(p => p.userId === userId);
        const foldedPlayers = players
            .filter(player => player.hasFoldedInCurrentGame)
            .map(player => player.userId);
        return {
            players,
            currentPlayer,
            isCurrentPlayerTurn: activePlayerId === userId,
            foldedPlayers,
        };
    });
    private timerInterval: NodeJS.Timeout | null = null;
    static contextType = DetachedWindowContext;
    declare context: React.ContextType<typeof DetachedWindowContext>;

    constructor(props: RoomProps) {
        super(props);

        if (props.roomState.type === 'aof') {
            ACTIVE_GAME_ROUNDS = ['dealing', 'returnSidePots', 'showdownFold', 'showdown'];
        } else if (props.roomState.type === 'texas') {
            ACTIVE_GAME_ROUNDS = ['preFlop', 'flop', 'turn', 'river', 'showdown', 'showdownFold'];
        }

        this.presentationStateApplier = new PokerPlayerPresentationApplier<SelectedAutoAction>({
            updateState: (updater) => this.setState((prevState) => updater(prevState)),
            triggerBalanceChangeAnimation: (userId) => this.triggerBalanceChangeAnimation(userId),
            queueAnimation: (amount) => this.queueAnimation(amount)
        });

        this.pokerPresentation = new PokerPresentation({
            initialCommunityCards: props.roomState.communityCards || [],
            getRoomId: () => this.props.roomState.roomId,
            getRoomIdentity: () => ({
                roomId: this.props.roomState.roomId,
                gameId: this.props.roomState.gameId,
                handId: this.props.roomState.handId
            }),
            getRoomType: () => this.props.roomState.type,
            getCurrentUserId: () => this.props.userState.id,
            audioPresetManager: this.audioPresetManager,
            isPlaybackAllowed: () => isGameplayAudioPlaybackAllowed(this.context, this.props.isSingleRoomView),
            applyActionBadge: this.presentationStateApplier.applyActionBadgePresentation,
            clearActionBadge: this.presentationStateApplier.clearActionBadge,
            clearActionBadges: this.presentationStateApplier.clearActionBadges,
            clearNonTerminalActionBadges: this.presentationStateApplier.clearNonTerminalActionBadges,
            applyWinnerIndicators: this.presentationStateApplier.applyWinnerIndicatorsPresentation,
            clearWinnerIndicators: this.presentationStateApplier.clearWinnerIndicators,
            setVisibleCommunityCards: (visibleCommunityCards) => this.setState({
                visibleCommunityCards,
                completedHandPresentationFadingOut: false
            }),
            clearCompletedHandPresentation: this.fadeOutCompletedHandPresentation,
            setAnimatedCommunityCardDelaysMs: (animatedCommunityCardDelaysMs) => this.setState({ animatedCommunityCardDelaysMs }),
            setShowdownCardsRevealKey: (showdownCardsRevealKey) => this.setState({ showdownCardsRevealKey }),
            setPlayerCardsVisible: (playerCardsVisible) => this.setState({
                playerCardsVisible,
                completedHandPresentationFadingOut: playerCardsVisible ? false : this.state.completedHandPresentationFadingOut
            })
        });

        this.state = {
            buyInAmount: props.roomState.minBuyIn,
            showSitFailedNoMoneyAlert: false,
            isCurrentUserSeatedAnywhere: false,
            betAmount: props.roomState.availableActions?.actions?.find(a =>
                a.type === 'raise' || a.type === 'bet'
            )?.minAmount || 0,
            actionBadges: {},
            winnerIndicators: {},
            visibleCommunityCards: this.pokerPresentation.getVisibleCommunityCards(),
            animatingChips: [],
            showAnimatedChip: false,
            isAnimating: false,
            animationQueue: [],
            balanceChanges: {},
            animatedCommunityCardDelaysMs: {},
            showdownCardsRevealKey: null,
            playerCardsVisible: true,
            completedHandPresentationFadingOut: false,
            isPinned: false,
            lastWinners: null,
            lastNonWinners: null,
            lastCommunityCards: null,
            lastPlayerTurnHistory: [],
            pinnedWinners: null,
            pinnedCommunityCards: null,
            pinnedPlayers: [],
            pinnedPlayerTurnHistory: [],
            pinnedNonWinners: null,
            pinnedGameId: null,
            currentTheme: this.getTheme(props.theme || 'modern'),
            activePlayerTimer: null,
            prevTurnStartTime: null,
            showBalanceAddSlider: false,
            balanceAddAmount: 0.1,
            hideActions: false,
            tempInputValue: '',
            showDebugPanel: false,
            isDebugPaused: false,
            availableActions: null,
            showWinModal: false,
            ante: props.roomState.ante,
            selectedAutoAction: props.roomState.autoActionIntent
                ? { type: props.roomState.autoActionIntent }
                : null,
            pendingBalanceUpdates: null,
            showTopUpOptions: false,
            topUpNextHandPlayers: new Set(),
            topUpAllHandsPlayers: new Set(),
            willSitOutNextHandPlayers: new Set(),
            isGameInfoExpanded: false,
            isMobileDrawerExpanded: false,
            playerEquities: null,
            hideCurrentBetChipsThisHand: false,
            copySuccess: null,
            showTournamentExtraInfo: false,
            showFullGameId: false,
            tournamentLobbyModalOpen: false,
            modalTournamentId: null,
            selectedAudioPresetId: this.audioPresetManager.getSelectedPresetId(),
            audioPresetMenuAnchorEl: null,
            isAudioMuted: getMuted() || getVolume() === 0,
            audioVolumeBeforeMute: null,
            gameplayActivityMessages: [],
            gameplayTurnHistory: [],
            tableReactionPickerTarget: null,
            activeTableReactions: [],
            showTableReactions: true,
            tableReactionCooldownUntil: null,
            tableReactionCooldownSecondsRemaining: 0,
            tableReactionStatus: null
        };

        this.handlePinToggle = this.handlePinToggle.bind(this);
        this.memoizedPlayerTurnHistory = this.normalizePlayerTurnHistory(props.roomState?.playerTurnHistory || []);
    }

    private ensureWillSitOutArray = (willSitOutNextHandPlayers: any): string[] => {
        return Array.isArray(willSitOutNextHandPlayers) ? willSitOutNextHandPlayers : [];
    };

    private normalizePlayerTurnHistory = (turnHistory: IJoinedRoomState['playerTurnHistory'] = []) => {
        if (!Array.isArray(turnHistory)) {
            return [];
        }

        return turnHistory.map(turn => ({
            ...turn,
            roundName: turn.roundName || 'Unknown',
            availableActions: turn.availableActions || [],
            pot: turn.pot || 0,
            communityCards: turn.communityCards || [],
            playerCurrentBets: turn.playerCurrentBets || [],
            playerBalances: turn.playerBalances || [],
            playerCards: turn.playerCards || [],
            smallBlindId: turn.smallBlindId || '',
            bigBlindId: turn.bigBlindId || '',
            smallBlindUsername: turn.smallBlindUsername || '',
            bigBlindUsername: turn.bigBlindUsername || '',
            dealerId: turn.dealerId || '',
            dealerUsername: turn.dealerUsername || '',
            selectedAction: turn.selectedAction || { action: '', amount: 0 }
        }));
    };

    private createGameplayActivityMessage = (event: IGameplayEvent): ActivityMessage | null => {
        const timestamp = event.serverTime;
        const currency = this.props.roomState.currency || undefined;

        switch (event.kind) {
            case 'handStarted':
                return {
                    template: 'systemMessage',
                    data: { timestamp, message: 'Hand started' }
                };
            case 'playerAction':
                if (!event.actorUsername || !event.action) return null;
                return {
                    template: 'playerAction',
                    data: {
                        timestamp,
                        username: event.actorUsername,
                        action: event.action,
                        amount: typeof event.amount === 'number' ? event.amount : 0,
                        currency
                    }
                };
            case 'streetDealt':
                if (!event.street) return null;
                return {
                    template: 'systemMessage',
                    data: {
                        timestamp,
                        message: `${event.street.charAt(0).toUpperCase()}${event.street.slice(1)} dealt`
                    }
                };
            case 'showdownStarted':
                return {
                    template: 'systemMessage',
                    data: { timestamp, message: 'Showdown started' }
                };
            case 'showdownCardsRevealed':
                return {
                    template: 'systemMessage',
                    data: { timestamp, message: 'Showdown cards revealed' }
                };
            case 'winnerDeclared': {
                const winners = Array.isArray(event.winners)
                    ? event.winners
                        .filter((winner) => Boolean(winner.username))
                        .map((winner) => ({
                            username: winner.username as string,
                            amount: typeof winner.winAmount === 'number' ? winner.winAmount : 0,
                            handRank: typeof winner.handName === 'string' ? winner.handName : '',
                            cards: Array.isArray(winner.winningCards) ? winner.winningCards : []
                        }))
                    : [];

                if (winners.length === 0) return null;
                return {
                    template: 'winners',
                    data: {
                        timestamp,
                        winners,
                        communityCards: this.props.roomState.communityCards || [],
                        currency
                    }
                };
            }
            default:
                return null;
        }
    };

    private createGameplayTurnHistoryEntry = (event: IGameplayEvent): GameInfoTurnHistoryEntry | null => {
        if (event.kind !== 'playerAction' || !event.actorUsername || !event.action) return null;

        return {
            time: event.serverTime,
            username: event.actorUsername,
            selectedAction: {
                action: event.action,
                amount: typeof event.amount === 'number' ? event.amount : 0
            }
        };
    };

    private updateGameInfoFromGameplayEvent = (event: IGameplayEvent) => {
        if (event.roomId !== this.props.roomState.roomId) return;

        const activityMessage = this.createGameplayActivityMessage(event);
        const turnHistoryEntry = this.createGameplayTurnHistoryEntry(event);

        if (!activityMessage && !turnHistoryEntry && event.kind !== 'handStarted') return;

        this.setState((prevState) => ({
            gameplayActivityMessages: activityMessage
                ? [...prevState.gameplayActivityMessages, activityMessage].slice(-80)
                : prevState.gameplayActivityMessages,
            gameplayTurnHistory: event.kind === 'handStarted'
                ? []
                : turnHistoryEntry
                    ? [...prevState.gameplayTurnHistory, turnHistoryEntry].slice(-80)
                    : prevState.gameplayTurnHistory
        }));
    };

    private handleAcceptedGameplayEvent = (event: IGameplayEvent) => {
        this.pokerPresentation.handleAcceptedGameplayEvent(event);
        this.updateGameInfoFromGameplayEvent(event);
    };

    private clearCompletedHandPresentationFadeOutTimer = () => {
        if (this.completedHandPresentationFadeOutTimer) {
            clearTimeout(this.completedHandPresentationFadeOutTimer);
            this.completedHandPresentationFadeOutTimer = null;
        }
    };

    private hasVisibleHandPresentationElements = (roomState: IJoinedRoomState = this.props.roomState): boolean => {
        if (this.state.visibleCommunityCards.length > 0) return true;
        if (Object.keys(this.state.winnerIndicators).length > 0) return true;

        if (!this.state.playerCardsVisible) return false;

        const hasShowdownCards = Array.isArray(roomState.showdownCards) &&
            roomState.showdownCards.length > 0;
        const canShowPlayerCards = shouldShowPlayerCardsForRoomState(
            roomState.type,
            roomState.stateName,
            this.state.playerCardsVisible
        );
        const hasActivePlayerCards = roomState.players.some((player) =>
            player.isActiveInCurrentGame && Array.isArray(player.cards) && player.cards.length > 0
        );
        const hasActiveCardBacks = canShowPlayerCards && roomState.players.some((player) =>
            player.isActiveInCurrentGame
        );

        return hasShowdownCards || hasActivePlayerCards || hasActiveCardBacks;
    };

    private clearCompletedHandPresentationImmediately = (
        visibleCommunityCards: string[],
        playerCardsVisibleAfterClear = false
    ) => {
        this.clearCompletedHandPresentationFadeOutTimer();
        this.setState({
            winnerIndicators: {},
            visibleCommunityCards,
            animatedCommunityCardDelaysMs: {},
            showdownCardsRevealKey: null,
            playerCardsVisible: playerCardsVisibleAfterClear,
            completedHandPresentationFadingOut: false
        });
    };

    private fadeOutCompletedHandPresentation = (
        visibleCommunityCards: string[],
        playerCardsVisibleAfterClear = false
    ) => {
        this.clearCompletedHandPresentationFadeOutTimer();

        if (!this.hasVisibleHandPresentationElements()) {
            this.clearCompletedHandPresentationImmediately(visibleCommunityCards, playerCardsVisibleAfterClear);
            return;
        }

        this.setState({ completedHandPresentationFadingOut: true });
        this.completedHandPresentationFadeOutTimer = setTimeout(() => {
            this.completedHandPresentationFadeOutTimer = null;
            this.setState((prevState) => ({
                winnerIndicators: {},
                animatedCommunityCardDelaysMs: {},
                showdownCardsRevealKey: null,
                completedHandPresentationFadingOut: false,
                visibleCommunityCards: prevState.completedHandPresentationFadingOut
                    ? visibleCommunityCards
                    : prevState.visibleCommunityCards,
                playerCardsVisible: prevState.completedHandPresentationFadingOut
                    ? playerCardsVisibleAfterClear
                    : prevState.playerCardsVisible
            }));
        }, HAND_PRESENTATION_FADE_OUT_MS);
    };

    componentDidMount() {
        if (!this.props.roomState || !this.props.roomState.initialized) {
            console.error(`[${new Date().toLocaleString()}] [aof-room] Room State not initialized or not present`);
        }
        this.updateActionTimer();
        this.startTimerInterval();
        this.unsubscribeGameplayEvents = roomGameplayEventBus.subscribe(this.handleAcceptedGameplayEvent);
        this.unsubscribeTableReactionEvents = roomTableReactionEventBus.subscribe(this.handleTableReactionEvent);
        this.pokerPresentation.applyRetainedWinnerDeclaredEvent(
            this.props.roomState.lastWinnerDeclaredEvent,
            this.props.roomState.lastWinnerDeclaredReceivedAt
        );

    }

    componentDidUpdate(prevProps: GameRoomInternalProps, _prevState: RoomState) {
        const currNotif = this.props.roomState.pendingNotification;
        // If there's a notification on the current room state, display it and clear it immediately
        if (currNotif) {
            if (this.props.roomEnqueueSnackbar) {
                const options = NotificationTemplateUtil.getSnackbarOptions(
                    { message: currNotif.message, type: currNotif.type },
                    currNotif.message,
                    this.props.roomCloseSnackbar
                );
                this.props.roomEnqueueSnackbar(options.content ? '' : currNotif.message, options);
            }

            this.props.updateRoomState({
                roomId: this.props.roomState.roomId,
                state: { pendingNotification: null }
            });
        }

        if (prevProps.theme !== this.props.theme) {
            this.setState({
                currentTheme: this.getTheme(this.props.theme || 'classic')
            });
        }
        // Reset state when switching to a different room
        if (prevProps.roomState.roomId !== this.props.roomState.roomId) {
            this.clearCompletedHandPresentationFadeOutTimer();
            this.clearTableReactionTimers();
            this.clearTableReactionCooldownTimer();
            this.clearTableReactionStatusTimer();
            this.pokerPresentation.resetRoom();
            const visibleCommunityCards = this.pokerPresentation.resetVisibleCommunityCardsToSnapshot(
                this.props.roomState.communityCards || []
            );

            this.setState({
                showWinModal: false,
                actionBadges: {},
                winnerIndicators: {},
                visibleCommunityCards,
                animatedCommunityCardDelaysMs: {},
                showdownCardsRevealKey: null,
                playerCardsVisible: true,
                completedHandPresentationFadingOut: false,
                selectedAutoAction: this.props.roomState.autoActionIntent
                    ? { type: this.props.roomState.autoActionIntent }
                    : null,
                gameplayActivityMessages: [],
                gameplayTurnHistory: [],
                tableReactionPickerTarget: null,
                activeTableReactions: [],
                showTableReactions: true,
                tableReactionCooldownUntil: null,
                tableReactionCooldownSecondsRemaining: 0,
                tableReactionStatus: null
            });

            // Restart the per-turn timer for the new room
            this.stopTimerInterval();
            this.updateActionTimer();
            this.startTimerInterval();
        } else if (this.state.tableReactionPickerTarget && !this.canCurrentUserSendTableReactions()) {
            this.setState({ tableReactionPickerTarget: null });
        }
        if (prevProps.roomState !== this.props.roomState) {
            if (!this.props.roomState || !this.props.roomState.initialized) {
                console.error(`[${new Date().toLocaleString()}] [texas-cash-room] Room State not initialized or not present after update`);
            }
            if (prevProps.roomState.playerTurnHistory !== this.props.roomState.playerTurnHistory) {
                this.memoizedPlayerTurnHistory = this.normalizePlayerTurnHistory(this.props.roomState.playerTurnHistory);
            }
        }

        const isNewHand = prevProps.roomState.gameId !== this.props.roomState.gameId || prevProps.roomState.handId !== this.props.roomState.handId;
        const didInitializeRoomState = !prevProps.roomState.initialized && this.props.roomState.initialized;
        if (isNewHand || didInitializeRoomState) {
            const snapshotCommunityCards = this.props.roomState.communityCards || [];
            const shouldFadeCompletedHandPresentation =
                isNewHand &&
                !didInitializeRoomState &&
                snapshotCommunityCards.length === 0 &&
                this.hasVisibleHandPresentationElements(prevProps.roomState);

            if (shouldFadeCompletedHandPresentation) {
                this.pokerPresentation.resetHand({
                    fadeCompletedHandPresentation: true,
                    playerCardsVisibleAfterClear: true
                });
            } else {
                this.clearCompletedHandPresentationFadeOutTimer();
                this.pokerPresentation.resetHand();
            }

            const visibleCommunityCards = shouldFadeCompletedHandPresentation
                ? null
                : this.pokerPresentation.resetVisibleCommunityCardsToSnapshot(snapshotCommunityCards);
            const selectedAutoAction = this.props.roomState.autoActionIntent
                ? { type: this.props.roomState.autoActionIntent }
                : null;

            const nextState: Pick<
                RoomState,
                | 'hideCurrentBetChipsThisHand'
                | 'actionBadges'
                | 'animatedCommunityCardDelaysMs'
                | 'showdownCardsRevealKey'
                | 'selectedAutoAction'
            > = {
                hideCurrentBetChipsThisHand: false,
                actionBadges: {},
                animatedCommunityCardDelaysMs: {},
                showdownCardsRevealKey: null,
                selectedAutoAction
            };

            if (visibleCommunityCards) {
                this.setState({
                    ...nextState,
                    visibleCommunityCards,
                    playerCardsVisible: true,
                    completedHandPresentationFadingOut: false,
                    gameplayTurnHistory: []
                });
            } else {
                this.setState({
                    ...nextState,
                    gameplayTurnHistory: []
                });
            }
        } else if (prevProps.roomState.communityCards !== this.props.roomState.communityCards) {
            const visibleCommunityCards = this.pokerPresentation.syncVisibleCommunityCardsToSnapshot(
                this.props.roomState.communityCards || []
            );
            if (visibleCommunityCards) {
                this.setState({
                    visibleCommunityCards,
                    completedHandPresentationFadingOut: false
                });
            }
        }

        if (
            prevProps.roomState.lastWinnerDeclaredEvent?.eventId !== this.props.roomState.lastWinnerDeclaredEvent?.eventId ||
            prevProps.roomState.lastWinnerDeclaredReceivedAt !== this.props.roomState.lastWinnerDeclaredReceivedAt
        ) {
            this.pokerPresentation.applyRetainedWinnerDeclaredEvent(
                this.props.roomState.lastWinnerDeclaredEvent,
                this.props.roomState.lastWinnerDeclaredReceivedAt
            );
        }

        const hasNewTurnBoundary =
            prevProps.roomState.activePlayerId !== this.props.roomState.activePlayerId ||
            prevProps.roomState.currentTurnStartTime !== this.props.roomState.currentTurnStartTime;

        if (hasNewTurnBoundary) {
            this.pokerPresentation.clearActionBadgeForTurnBoundary(this.props.roomState.activePlayerId || undefined);
        }

        if (!this.props.isSingleRoomView) {
            return;
        }

        if (
            this.props.roomState.winners !== prevProps.roomState.winners &&
            this.props.roomState.winners &&
            this.props.roomState.winners.length > 0
        ) {
            this.presentationStateApplier.clearActionBadges();

            this.setState({
                showWinModal: false,
                lastWinners: this.props.roomState.winners,
                lastNonWinners: this.props.roomState.nonWinners,
                lastCommunityCards: this.props.roomState.communityCards,
                lastPlayerTurnHistory: this.props.roomState.playerTurnHistory,
            });
        }

        // Update timer when active player or turn time changes
        if (
            prevProps.roomState.activePlayerId !== this.props.roomState.activePlayerId ||
            prevProps.roomState.currentTurnStartTime !== this.props.roomState.currentTurnStartTime ||
            prevProps.roomState.turnTime !== this.props.roomState.turnTime
        ) {
            // Stop existing interval before starting new one
            this.stopTimerInterval();
            this.updateActionTimer();
            this.startTimerInterval();
        }

        // Reset hideActions when it becomes player's turn OR when available actions change
        if ((prevProps.roomState.activePlayerId !== this.props.roomState.activePlayerId &&
            this.props.roomState.activePlayerId === this.props.userState.id) ||
            (prevProps.roomState.availableActions !== this.props.roomState.availableActions &&
                this.props.roomState.activePlayerId === this.props.userState.id)) {
            this.setState({ hideActions: false });
        }

        // Update betAmount when availableActions change
        if (prevProps.roomState.availableActions !== this.props.roomState.availableActions) {
            const raiseOrBetAction = this.props.roomState.availableActions?.actions?.find(a =>
                a.type === 'raise' || a.type === 'bet'
            );

            if (raiseOrBetAction) {
                this.setState({
                    betAmount: raiseOrBetAction.minAmount
                });
            }
        }

        if (prevProps.roomState.autoActionIntent !== this.props.roomState.autoActionIntent) {
            this.setState({
                selectedAutoAction: this.props.roomState.autoActionIntent
                    ? { type: this.props.roomState.autoActionIntent }
                    : null
            });
        }

        // Handle visibleSidePots logic for hiding chip displays in Texas Hold'em
        if (this.props.roomState.type === 'texas') {
            const currentVisibleSidePots = this.props.roomState.visibleSidePots;
            const prevVisibleSidePots = prevProps.roomState.visibleSidePots;
            const hasSidePots = currentVisibleSidePots && currentVisibleSidePots.length > 0;
            const hadSidePots = prevVisibleSidePots && prevVisibleSidePots.length > 0;
            
            // If sidePots become non-empty and we're not already hiding chips, set flag to true
            if (hasSidePots && !hadSidePots && !this.state.hideCurrentBetChipsThisHand) {
                this.setState({ hideCurrentBetChipsThisHand: true });
            }
            
            // If sidePots become empty and we were hiding chips, reset flag to false
            // This handles the case where visibleSidePots is cleared between hands
            if (!hasSidePots && hadSidePots && this.state.hideCurrentBetChipsThisHand) {
                this.setState({ hideCurrentBetChipsThisHand: false });
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribeGameplayEvents?.();
        this.unsubscribeGameplayEvents = null;
        this.unsubscribeTableReactionEvents?.();
        this.unsubscribeTableReactionEvents = null;
        this.clearTableReactionTimers();
        this.clearTableReactionCooldownTimer();
        this.clearTableReactionStatusTimer();
        this.clearCompletedHandPresentationFadeOutTimer();
        this.pokerPresentation.dispose();
        this.stopTimerInterval();
    }

    handleGameInfoCollapseChange = (isGameInfoExpanded: boolean) => {
        this.setState({ isGameInfoExpanded });
    };

    updateActionTimer = () => {
        const { activePlayerId, turnTime, currentTurnStartTime } = this.props.roomState;

        if (!activePlayerId || !turnTime || !currentTurnStartTime) {
            this.setState({ activePlayerTimer: null });
            return;
        }

        try {
            // If it's a new turn (different turn start time), always start with full time
            if (this.state.prevTurnStartTime !== currentTurnStartTime) {
                this.setState({
                    activePlayerTimer: turnTime,
                    prevTurnStartTime: currentTurnStartTime
                });
                return;
            }

            // For ongoing turns, calculate remaining time
            const startTime = new Date(currentTurnStartTime).getTime();
            const currentTime = new Date().getTime();
            const elapsedTime = Math.floor((currentTime - startTime) / 1000);
            const remainingTime = Math.max(0, turnTime - elapsedTime);

            this.setState({ activePlayerTimer: remainingTime });
        } catch (error) {
            console.error('Error updating action timer:', error);
            this.setState({ activePlayerTimer: null });
        }
    }

    startTimerInterval = () => {
        this.stopTimerInterval();
        this.timerInterval = setInterval(() => {
            const { activePlayerId, turnTime, currentTurnStartTime } = this.props.roomState;

            if (!activePlayerId || !turnTime || !currentTurnStartTime) {
                return;
            }

            // Always calculate based on server time
            const startTime = new Date(currentTurnStartTime).getTime();
            const currentTime = new Date().getTime();
            const elapsedTime = Math.floor((currentTime - startTime) / 1000);
            const remainingTime = Math.max(0, turnTime - elapsedTime);

            this.setState({ activePlayerTimer: remainingTime });
        }, 1000);
    }

    stopTimerInterval = () => {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
    }

    handlePinToggle() {
        this.setState(prevState => {
            if (!prevState.isPinned) {
                return {
                    ...prevState,
                    isPinned: true,
                    pinnedWinners: this.props.roomState.winners,
                    pinnedNonWinners: this.props.roomState.nonWinners,
                    pinnedCommunityCards: this.props.roomState.communityCards,
                    pinnedPlayers: this.props.roomState.players,
                    pinnedPlayerTurnHistory: this.props.roomState.playerTurnHistory,
                    pinnedGameId: this.props.roomState.gameId,
                };
            } else {
                return {
                    ...prevState,
                    isPinned: false,
                    pinnedWinners: null,
                    pinnedNonWinners: null,
                    pinnedCommunityCards: null,
                    pinnedPlayers: [],
                    pinnedPlayerTurnHistory: [],
                    pinnedGameId: null,
                };
            }
        });
    }

    handleSitButtonClick = (position: number) => {
        this.props.requestSitOptions(this.props.roomState.roomId, position);
    };

    handleSitOptionsConfirm = (buyInAmount: number, postOrWaitChoice?: 'post' | 'wait') => {
        if (this.props.roomState.sitOptions?.gameState?.balanceWarning) {
            // If it's a balance warning, send balance update
            this.props.sendBalanceUpdate(
                this.props.roomState.roomId,
                this.props.userState.id,
                buyInAmount
            );
        } else {
            // If it's a sit request, handle as before
            if (this.props.roomState.sitOptions) {
                this.props.requestSit(
                    this.props.roomState.roomId,
                    this.props.roomState.sitOptions.seatIndex,
                    buyInAmount,
                    postOrWaitChoice
                );
            }
        }

        // Close modal after request
        this.props.updateRoomState({
            roomId: this.props.roomState.roomId,
            state: {
                showSitOptionsModal: false,
                sitOptions: null
            }
        });
    };


    handleStandFromTable = () => {
        // Prevent standing up during tournaments
        if (this.props.roomState.isTournamentTable) {
            return;
        }
        
        this.props.standFromRoom(this.props.roomState.roomId);
        this.setState({ isCurrentUserSeatedAnywhere: false });
        this.props.updateRoomState({
            roomId: this.props.roomState.roomId,
            state: { showLeaveSeatDialog: false }
        });
    };

    handleLeaveRoom = () => {
        if (this.props.roomState.roomId) {
            this.props.updateRoomState({
                roomId: this.props.roomState.roomId,
                state: { showLeaveRoomDialog: false }
            });
            this.props.leaveRoom(this.props.roomState.roomId);
        } else {
            console.error(`[${new Date().toLocaleString()}] [texas-cash-room] Room ID is undefined when trying to leave room`);
        }
    };

    handleSwitchToLobby = () => {
        this.props.switchToLobby();
    };

    handleTournamentLobbyClick = () => {
        if (this.props.roomState.tournamentGameId) {
            this.setState({
                modalTournamentId: this.props.roomState.tournamentGameId,
                tournamentLobbyModalOpen: true
            });
        }
    }

    handleTournamentLobbyModalClose = () => {
        this.setState({
            tournamentLobbyModalOpen: false,
            modalTournamentId: null
        });
    }

    getTournamentData = (): ITournamentState | null => {
        if (!this.state.modalTournamentId) {
            return null;
        }

        if (typeof window !== 'undefined') {
            const interactionHandler = (window as any).interactionHandler as InteractionHandler | undefined;
            if (interactionHandler && (interactionHandler as any).model) {
                const appState = (interactionHandler as any).model.app.state;
                const tournaments: ITournamentState[] = appState.lobbyTournament.tournaments;

                if (tournaments.length > 0) {
                    const found = tournaments.find((t: ITournamentState) => t.gameId === this.state.modalTournamentId);
                    if (found) {
                        return found;
                    }
                }
            }
        }
        
        console.warn('Tournament not found. modalTournamentId:', this.state.modalTournamentId);
        return null;
    }

    handleBetAmountChange = debounce((newValue: number | number[] | React.ChangeEvent<HTMLInputElement> | string) => {
        let value: number;
        const raiseOrBetAction = this.props.roomState.availableActions?.actions?.find(a =>
            a.type === 'raise' || a.type === 'bet'
        );
        const currencyType = this.props.roomState.currencyType; // Get currency type

        if (!raiseOrBetAction) return;

        const decimals = CurrencyDecimals.getCurrencyDecimals(currencyType, this.props.roomState.currency);
        const roundValue = (val: number) => {
            const factor = Math.pow(10, decimals);
            return Math.round(val * factor) / factor;
        };

        if (typeof newValue === 'string') {
            // Get live pot (Texas)
            const totalPot = getTexasPresetBasePot(this.props.roomState);
            switch (newValue) {
                case 'halfPot':
                    value = totalPot ? roundValue(totalPot / 2) : raiseOrBetAction.minAmount;
                    break;
                case 'threeFourthsPot':
                    value = totalPot ? roundValue(totalPot * 3 / 4) : raiseOrBetAction.minAmount;
                    break;
                case 'fullPot':
                    value = totalPot || raiseOrBetAction.minAmount;
                    value = roundValue(value); // Round pot value
                    break;
                default:
                     const parsedValue = parseFloat(newValue);
                     value = isNaN(parsedValue) ? raiseOrBetAction.minAmount : roundValue(parsedValue);
            }
        } else if (typeof newValue === 'number') {
            value = roundValue(newValue);
        } else if (Array.isArray(newValue)) {
            value = roundValue(newValue[0]);
        } else {
            const parsedValue = parseFloat(newValue.target.value);
            value = isNaN(parsedValue) ? raiseOrBetAction.minAmount : roundValue(parsedValue);
        }
        value = Math.max(raiseOrBetAction.minAmount, Math.min(raiseOrBetAction.maxAmount, value));

        this.setState({ betAmount: value });
    }, 50);

    sendAction = (actionType: string, amount: number) => {
        this.setState({
            hideActions: true
        });

        const clamp = (val: number, min: number, max: number) => Math.max(min, Math.min(max, val));

        const decimals = CurrencyDecimals.getCurrencyDecimals(this.props.roomState.currencyType, this.props.roomState.currency);
        const roundToCurrencyDecimals = (val: number) => {
            const factor = Math.pow(10, decimals);
            return Math.round(val * factor) / factor;
        };

        const availableActions = this.props.roomState.availableActions?.actions || [];
        const action = availableActions.find(a => a.type === actionType) || null;
        if (!action) {
            this.setState({
                hideActions: false
            });
            return;
        }

        let finalAmount = amount;
        if (actionType === 'all-in') {
            finalAmount = action.maxAmount;
        } else if (actionType === 'check' || actionType === 'fold') {
            finalAmount = action.minAmount;
        } else {
            finalAmount = roundToCurrencyDecimals(amount);
            finalAmount = clamp(finalAmount, action.minAmount, action.maxAmount);
        }

        this.props.sendAction(this.props.roomState.roomId, actionType, finalAmount, this.props.userState.id);
    };

    renderCardImage = (card: any, small: boolean = false, community: boolean = false) => {
        const style = community ? {
            width: '100%',
            height: '100%',
            objectFit: 'contain' as 'contain',
            maxHeight: '180px',
            margin: 0,
        } : undefined;

        return <CardImage card={`${card}`} small={small} community={community} style={style} type='dark' />;
    };

    renderMessageWithCards = (message: string) => {
        if (!message) return null;

        const parts = message.split(/(PC\*\[[^\]]+\])/);
        return parts.map((part, index) => {
            if (part.startsWith('PC*[') && part.endsWith(']')) {
                const card = part.slice(4, -1);
                return <CardImage key={index} card={card} extraSmall type='dark' />;
            }
            return <span key={index}>{part}</span>;
        });
    };

    formatNumber(num: number): string {
        const rounded = Math.floor(num * 100) / 100;
        return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(2);
    }

    private isTournamentChipRoom = (): boolean => (
        this.props.roomState.isTournamentTable === true ||
        this.props.roomState.currencyType === 'tournament_chips' ||
        Boolean(this.props.roomState.tournamentGameId || this.props.roomState.tournamentId)
    );

    private getDisplayCurrencyType = (): 'fiat' | 'crypto' | 'tournament_chips' => (
        this.isTournamentChipRoom() ? 'tournament_chips' : this.props.roomState.currencyType
    );

    private getDisplayCurrency = (): string => (
        this.isTournamentChipRoom() ? '' : this.props.roomState.currency
    );

    formatCurrency = (amount: number): string => {
        if (amount === null || amount === undefined) return ''; // Handle null/undefined input
        const { currency, currencyType } = this.props.roomState || {};

        // Handle chip-like currencies first (no decimals)
        if (this.isTournamentChipRoom() || currencyType === 'tournament_chips') {
            return `${Math.floor(amount).toLocaleString()}`;
        }

        const valueToFormat = Math.floor(amount * 100) / 100; // Round to 2 decimals for others

        if (currencyType === 'crypto' && currency) {
            // For crypto, show amount with 2 decimals and currency code
            return `${valueToFormat.toFixed(2)} ${currency.toUpperCase()}`;
        }

        // Handle fiat (ensure currency code is valid for Intl.NumberFormat)
        // Check if currency is potentially invalid (like 'chips'), default to USD if so.
        const validCurrencyCode = (currency && currency.length === 3 && currency.toUpperCase() !== 'XXX') ? currency : 'USD';
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: validCurrencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(valueToFormat);
    }

    getStakeLevel = () => {
        const buyIn = this.props.roomState.ante * 20;
        if (buyIn < 5) {
            return 'low';
        } else if (buyIn < 100) {
            return 'mid';
        } else {
            return 'high';
        }
    }

    triggerBalanceChangeAnimation = (userId: string) => {
        this.setState(prevState => ({
            balanceChanges: {
                ...prevState.balanceChanges,
                [userId]: 1,
            },
        }));

        setTimeout(() => {
            this.setState(prevState => ({
                balanceChanges: {
                    ...prevState.balanceChanges,
                    [userId]: 0,
                },
            }));
        }, 500);
    };

    queueAnimation = (amount: number) => {
        this.setState(
            prevState => ({ animationQueue: [...prevState.animationQueue, amount] }),
            this.processAnimationQueue
        );
    };

    processAnimationQueue = () => {
        if (this.state.animationQueue.length > 0 && !this.state.isAnimating) {
            const [nextAmount, ...restQueue] = this.state.animationQueue;
            this.setState({ isAnimating: true, showAnimatedChip: true, animationQueue: restQueue });

            setTimeout(() => {
                this.setState({ showAnimatedChip: false, isAnimating: false }, () => {
                    setTimeout(this.processAnimationQueue, 50);
                });
            }, 300);
        }
    };

    private getTableReactionDocument = (): Document => {
        const detachedWindow = this.context;
        return detachedWindow && !detachedWindow.closed
            ? detachedWindow.document
            : document;
    };

    private getTableReactionOverlayElement = (): HTMLElement | null => {
        const doc = this.getTableReactionDocument();
        const overlays = Array.from(doc.querySelectorAll('[data-poker-table-reaction-overlay-room-id]')) as HTMLElement[];

        return overlays.find((overlay) =>
            overlay.getAttribute('data-poker-table-reaction-overlay-room-id') === this.props.roomState.roomId
        ) || null;
    };

    private getTableReactionPoint = (userId: string): PokerTableReactionPoint | null => {
        const doc = this.getTableReactionDocument();
        const overlay = this.getTableReactionOverlayElement();
        if (!overlay) return null;

        const anchors = Array.from(doc.querySelectorAll('[data-poker-reaction-player-avatar]')) as HTMLElement[];
        const anchor = anchors.find((element) =>
            element.getAttribute('data-poker-reaction-player-avatar') === userId
        );
        if (!anchor) return null;

        const anchorBounds = anchor.getBoundingClientRect();
        const overlayBounds = overlay.getBoundingClientRect();

        return {
            x: anchorBounds.left - overlayBounds.left + (anchorBounds.width / 2),
            y: anchorBounds.top - overlayBounds.top + (anchorBounds.height / 2)
        };
    };

    private clearTableReactionTimers = () => {
        this.tableReactionTimers.forEach((timer) => clearTimeout(timer));
        this.tableReactionTimers = [];
    };

    private clearTableReactionAnimations = () => {
        this.clearTableReactionTimers();
        this.setState({ activeTableReactions: [] });
    };

    private clearTableReactionCooldownTimer = () => {
        if (this.tableReactionCooldownTimer) {
            clearTimeout(this.tableReactionCooldownTimer);
            this.tableReactionCooldownTimer = null;
        }
    };

    private clearTableReactionStatusTimer = () => {
        if (this.tableReactionStatusTimer) {
            clearTimeout(this.tableReactionStatusTimer);
            this.tableReactionStatusTimer = null;
        }
    };

    private scheduleTableReactionCooldownTick = (cooldownUntil: number) => {
        this.clearTableReactionCooldownTimer();

        const secondsRemaining = Math.max(0, Math.ceil((cooldownUntil - Date.now()) / 1000));
        if (secondsRemaining <= 0) {
            this.setState({
                tableReactionCooldownUntil: null,
                tableReactionCooldownSecondsRemaining: 0
            });
            return;
        }

        this.setState({
            tableReactionCooldownUntil: cooldownUntil,
            tableReactionCooldownSecondsRemaining: secondsRemaining
        });

        this.tableReactionCooldownTimer = setTimeout(() => {
            this.scheduleTableReactionCooldownTick(cooldownUntil);
        }, 1000);
    };

    private startTableReactionCooldown = () => {
        this.scheduleTableReactionCooldownTick(Date.now() + POKER_TABLE_REACTION_SEND_COOLDOWN_MS);
    };

    private showTableReactionStatus = (event: ITableReactionEvent) => {
        const reaction = getPokerTableReaction(event.reactionId);
        this.clearTableReactionStatusTimer();
        this.setState({
            tableReactionStatus: {
                id: event.reactionEventId,
                sourceUsername: event.sourceUsername,
                targetUsername: event.targetUsername,
                reactionLabel: reaction.label,
                reactionAssetUrl: reaction.assetUrl
            }
        });

        this.tableReactionStatusTimer = setTimeout(() => {
            this.setState({ tableReactionStatus: null });
            this.tableReactionStatusTimer = null;
        }, 2400);
    };

    private isTableReactionSendOnCooldown = (): boolean => (
        Boolean(this.state.tableReactionCooldownUntil && Date.now() < this.state.tableReactionCooldownUntil)
    );

    private rememberTableReactionEventId = (reactionEventId: string) => {
        this.handledTableReactionIds.add(reactionEventId);
        this.handledTableReactionIdOrder.push(reactionEventId);

        while (this.handledTableReactionIdOrder.length > 200) {
            const oldReactionEventId = this.handledTableReactionIdOrder.shift();
            if (oldReactionEventId) {
                this.handledTableReactionIds.delete(oldReactionEventId);
            }
        }
    };

    private handleTableReactionEvent = (event: ITableReactionEvent) => {
        if (event.roomId !== this.props.roomState.roomId) return;
        if (this.handledTableReactionIds.has(event.reactionEventId)) return;

        this.rememberTableReactionEventId(event.reactionEventId);
        if (!this.state.showTableReactions) return;

        this.showTableReactionStatus(event);

        const source = this.getTableReactionPoint(event.sourceUserId);
        const target = this.getTableReactionPoint(event.targetUserId);
        if (!source || !target) return;

        const animationId = `${event.reactionEventId}:${Date.now()}`;
        const reaction: ActivePokerTableReaction = {
            animationId,
            reactionId: event.reactionId,
            source,
            target
        };

        this.setState((prevState) => ({
            activeTableReactions: [...prevState.activeTableReactions, reaction].slice(-10)
        }));

        const timer = setTimeout(() => {
            this.setState((prevState) => ({
                activeTableReactions: prevState.activeTableReactions.filter((item) => item.animationId !== animationId)
            }));
            this.tableReactionTimers = this.tableReactionTimers.filter((storedTimer) => storedTimer !== timer);
        }, POKER_TABLE_REACTION_LIFETIME_MS);

        this.tableReactionTimers.push(timer);
    };

    private getCurrentUserTablePlayer = (): IPlayerState | undefined => (
        this.props.roomState.players.find((player) => player.userId === this.props.userState.id)
    );

    private canCurrentUserSendTableReactions = (): boolean => {
        const currentPlayer = this.getCurrentUserTablePlayer();
        if (!currentPlayer || currentPlayer.seatIndex === null || currentPlayer.seatIndex === undefined) {
            return false;
        }

        if (this.props.roomState.isTournamentTable) {
            return true;
        }

        if (this.props.roomState.type !== 'texas' && this.props.roomState.type !== 'aof') {
            return true;
        }

        const isWaitingForBigBlind = this.props.roomState.type === 'texas' &&
            this.ensureWillSitOutArray(this.props.roomState.playersWaitingForBB).includes(currentPlayer.userId);

        return !isWaitingForBigBlind &&
            !currentPlayer.isSitOut &&
            !currentPlayer.isDisconnected &&
            !currentPlayer.isWaitingForNextHand &&
            !currentPlayer.willSitOutNextGame &&
            currentPlayer.isActiveInCurrentGame;
    };

    private canOpenTableReactionPickerForPlayer = (player: IPlayerState | null | undefined): boolean => (
        Boolean(player) &&
        player?.userId !== this.props.userState.id &&
        this.canCurrentUserSendTableReactions()
    );

    private handleOpenTableReactionPicker = (player: IPlayerState, anchorEl: HTMLElement) => {
        if (!this.canOpenTableReactionPickerForPlayer(player)) return;

        this.setState({
            tableReactionPickerTarget: {
                userId: player.userId,
                username: player.username,
                anchorEl
            }
        });
    };

    private handleCloseTableReactionPicker = () => {
        this.setState({ tableReactionPickerTarget: null });
    };

    private handleSelectTableReaction = (reactionId: TableReactionId) => {
        const target = this.state.tableReactionPickerTarget;
        if (!target) return;
        if (this.isTableReactionSendOnCooldown()) return;

        this.props.requestSendTableReaction(
            this.props.roomState.roomId,
            target.userId,
            reactionId
        );
        this.startTableReactionCooldown();
        this.handleCloseTableReactionPicker();
    };

    private handleToggleTableReactions = () => {
        const shouldShow = !this.state.showTableReactions;
        if (!shouldShow) {
            this.clearTableReactionAnimations();
            this.clearTableReactionStatusTimer();
        }

        this.setState({
            showTableReactions: shouldShow,
            tableReactionStatus: shouldShow ? this.state.tableReactionStatus : null
        });
    };

    getSlotPosition = (index: number): {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
        marginTop?: string;
        marginBottom?: string;
    } => {
        const isAofRoom = this.props.roomState.type === 'aof';
        const desktopPositions = [
            { top: '0%', left: '13%', transform: 'translateY(-40px)' },
            { top: '0%', right: '13%', transform: 'translateY(-40px)' },
            { bottom: isAofRoom ? '0%' : '34%', right: isAofRoom ? '50%' : '0px', transform: isAofRoom ? 'translate(50%, 40px)' : 'translateX(50px)' },
            { bottom: '0%', right: '13%', transform: 'translateY(40px)' },
            { bottom: '0%', left: '13%', transform: 'translateY(40px)' },
            { bottom: '34%', left: '0px', transform: 'translateX(-50px)' },
        ];

        const mobilePositions = [
            isAofRoom ? { top: '17%', left: '0px', transform: '' } : { top: '0px', left: '50%', transform: 'translate(-50%, -40%)' },
            { top: '17%', right: '0px', transform: '' },
            isAofRoom ? { bottom: '0px', left: '50%', transform: 'translate(-50%, 25px)' } : { top: '50%', right: '0px', transform: '' },
            { bottom: '0px', left: '50%', transform: 'translate(-50%, 25px)' },
            { top: '50%', left: '0px', transform: '' },
            { top: '17%', left: '0px', transform: '' },
        ];

        const positions = isMobile ? mobilePositions : desktopPositions;
        return positions[index];
    };

    getSlotClassName = (index: number): string => {
        const desktopClassNames = [
            styles.topLeft,
            styles.topRight,
            styles.right,
            styles.bottomRight,
            styles.bottomLeft,
            styles.left
        ];
        const mobileClassNames = [
            styles.mobileTop,
            styles.mobileTopRight,
            styles.mobileBottomRight,
            styles.mobileBottom,
            styles.mobileBottomLeft,
            styles.mobileTopLeft
        ];
        const classNames = isMobile ? mobileClassNames : desktopClassNames;
        return classNames[index];
    }

    getPlayerButtonPosition = (index: number): {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
    } => {
        const desktopPositions = [
            { top: '0', left: '0', transform: 'translate(-10px, -20px)' },
            { top: '0', left: '0', transform: 'translate(-10px, -20px)' },
            { top: '0', left: '0', transform: 'translate(-10px, -20px)' },
            { top: '0', left: '0', transform: 'translate(-10px, -20px)' },
            { top: '0', left: '0', transform: 'translate(-10px, -20px)' },
            { top: '0', left: '0', transform: 'translate(-10px, -20px)' },
        ];

        const mobilePositions = [
            { top: '-5px', left: '0' },
            { top: '-5px', left: '0' },
            { top: '-5px', left: '0' },
            { top: '-5px', left: '0' },
            { top: '-5px', right: '0' },
            { top: '-5px', right: '0' },
        ];

        const positions = isMobile ? mobilePositions : desktopPositions;
        return positions[index];
    }

    getCardPosition = (index: number): {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
        marginTop?: string;
        marginBottom?: string;
        marginLeft?: string;
        marginRight?: string;
    } => {
        const isAofRoom = this.props.roomState.type === 'aof';
        const desktopCardPositions = [
            { bottom: '0px', left: '100%', transform: '', '--x': '0px' },
            { bottom: '0px', right: '100%', transform: 'translateX(30%)', '--x': '30px' },
            { bottom: '50%', right: '110%', transform: 'translateX(30%)', '--x': '30px' },
            { bottom: '0px', right: '100%', transform: 'translateX(30%)', '--x': '30px' },
            { bottom: '0px', left: '100%', transform: '', '--x': '0px' },
            { bottom: '50%', left: '110%', transform: '', '--x': '0px' },
        ];

        const mobileCardPositions = [
            isAofRoom ? { bottom: '65px', left: '100%', transform: 'translateX(10%)', '--x': '10%' } : { bottom: '-15px', left: '50%', transform: 'translateX(-30%)', '--x': '-30%' },
            { bottom: '60px', right: '100%', transform: 'translateX(30%)', '--x': '30%' },
            isAofRoom ? { top: '-36px', left: '50%', transform: 'translateX(-30%)', '--x': '-30%' } : { bottom: '20px', right: '100%', transform: 'translateX(30%)', '--x': '30%' },
            { top: '-36px', left: '50%', transform: 'translateX(-30%)', '--x': '-30%' },
            { bottom: '20px', left: '100%', transform: 'translateX(10%)', '--x': '10%' },
            { bottom: '60px', left: '100%', transform: 'translateX(10%)', '--x': '10%' },
        ];

        const positions = isMobile ? mobileCardPositions : desktopCardPositions;
        return positions[index];
    };

    getVisibleCardPosition = (index: number): {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
        marginTop?: string;
        marginBottom?: string;
        marginLeft?: string;
        marginRight?: string;
    } => {
        const isAofRoom = this.props.roomState.type === 'aof';
        const desktopCardPositions = [
            { bottom: '0', left: '100%', marginLeft: '10px', '--x': '0px' },
            { bottom: '0', left: '100%', marginLeft: '10px', '--x': '0px' },
            { bottom: '0', left: '100%', marginLeft: '10px', '--x': '0px' },
            { bottom: '0', left: '100%', marginLeft: '10px', '--x': '0px' },
            { bottom: '0', left: '100%', marginLeft: '10px', '--x': '0px' },
            { bottom: '0', left: '100%', marginLeft: '10px', '--x': '0px' },
        ];
        const mobileCardPositions = [
            { top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: '50px', '--x': '-50%' },
            { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: '20px', '--x': '-50%' },
            { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: isAofRoom ? '28px' : '20px', '--x': '-50%' },
            { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: '28px', '--x': '-50%' },
            { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: '20px', '--x': '-50%' },
            { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: '20px', '--x': '-50%' },
        ];
        const cardPositions = isMobile ? mobileCardPositions : desktopCardPositions;
        return cardPositions[index];
    };

    getShowdownCardPosition = (index: number): {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
        marginTop?: string;
        marginBottom?: string;
        marginLeft?: string;
        marginRight?: string;
    } => {
        const isAofRoom = this.props.roomState.type === 'aof';
        const desktopCardPositions = [
            { bottom: '0', left: '100%', marginLeft: '10px' },
            { bottom: '0', right: '100%', marginRight: '10px' },
            { bottom: '0', right: '100%', marginRight: '10px' },
            { bottom: '0', right: '100%', marginRight: '10px' },
            { bottom: '0', left: '100%', marginLeft: '10px' },
            { bottom: '0', left: '100%', marginLeft: '10px' },
        ];
        const mobileCardPositions = [
            isAofRoom ? { bottom: '65px', left: '100%', transform: 'translateX(10%)' } : { bottom: '-36px', left: '50%', transform: 'translateX(-50%)' },
            isAofRoom ? { bottom: '65px', right: '100%', transform: 'translateX(-10%)' } : { bottom: '35px', right: '100%', transform: 'translateX(-10%)' },
            isAofRoom ? { top: '-44px', left: '50%', transform: 'translateX(-50%)' } : { bottom: '30px', right: '100%', transform: 'translateX(-10%)' },
            { top: '-68px', left: '50%', transform: 'translateX(-50%)' },
            { bottom: '30px', left: '100%', transform: 'translateX(10%)' },
            { bottom: '35px', left: '100%', transform: 'translateX(10%)' },
        ];
        const cardPositions = isMobile ? mobileCardPositions : desktopCardPositions;
        return cardPositions[index];
    };

    getChipPosition = (index: number): {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
        marginTop?: string;
        marginBottom?: string;
        background?: string;
    } => {
        const isAofRoom = this.props.roomState.type === 'aof';
        const desktopChipPositions = [
            { bottom: '-15px', right: '8px', transform: '', zIndex: 1 },
            { bottom: '-15px', left: '8px', transform: '', zIndex: 1 },
            { top: isAofRoom ? '-64px' : '65%', right: isAofRoom ? '50%' : '60%', transform: isAofRoom ? 'translateX(50%)' : '', zIndex: 1, marginRight: isAofRoom ? '0' : '55px' },
            { top: '-50px', right: '80%', transform: '', zIndex: 1 },
            { top: '-50px', left: '80%', transform: '', zIndex: 1 },
            { top: '65%', left: '60%', transform: '', zIndex: 1, marginLeft: '55px' },
        ];

        const mobileChipPositions = [
            isAofRoom ? { bottom: '35px', left: '100%', transform: '', zIndex: 1 } : { bottom: '-35px', left: '50%', transform: 'translateX(-50%)', zIndex: 1 },
            { bottom: '35px', right: '100%', transform: '', zIndex: 1 },
            isAofRoom ? { top: '-65px', left: '50%', transform: 'translateX(-50%)', zIndex: 1 } : { bottom: '60px', right: '100%', transform: 'translateX(-5%)', zIndex: 1 },
            { top: '-65px', left: '50%', transform: 'translateX(-50%)', zIndex: 1 },
            { bottom: '60px', left: '100%', transform: 'translateX(5%)', zIndex: 1 },
            { bottom: '35px', left: '100%', transform: '', zIndex: 1 },
        ];

        const positions = isMobile ? mobileChipPositions : desktopChipPositions;
        return positions[index];
    };

    getActionPosition = (index: number): React.CSSProperties => {
        const isAofRoom = this.props.roomState.type === 'aof';
        const desktopActionPositions = [
            { top: '-36px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-36px', left: '50%', transform: 'translateX(-50%)' },
            { top: isAofRoom ? '-36px' : '-36px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-36px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-36px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-36px', left: '50%', transform: 'translateX(-50%)' },
        ];
        const mobileActionPositions = [
            { top: '-24px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-24px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-24px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-24px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-24px', left: '50%', transform: 'translateX(-50%)' },
            { top: '-24px', left: '50%', transform: 'translateX(-50%)' },
        ];
        const actionPositions = isMobile ? mobileActionPositions : desktopActionPositions;
        return actionPositions[index];
    };

    getPlayerInfoStyles = (index: number): {
        width: string;
        textAlign?: string;
    } => {
        const desktopSizes = [
            { width: 'calc(252px - 160px)' },
            { width: 'calc(252px - 160px)' },
            { width: 'calc(252px - 160px)' },
            { width: 'calc(252px - 160px)' },
            { width: 'calc(252px - 160px)' },
            { width: 'calc(252px - 160px)' },
        ];
        const mobileSizes = [
            { width: '52px' },
            { width: '67px', textAlign: 'center !important' },
            { width: '67px', textAlign: 'center !important' },
            { width: '52px' },
            { width: '67px', textAlign: 'center !important' },
            { width: '67px', textAlign: 'center !important' },
        ];
        const playerInfoSizes = isMobile ? mobileSizes : desktopSizes;
        return playerInfoSizes[index];
    }

    renderPlayerSlot = (index: number) => {
        const player = this.props.roomState.players.find(p => p.seatIndex === index);

        const isCurrentUserSeatedAnywhere = this.props.roomState.players.some(p => p.userId === this.props.userState.id);
        let adjustedSeatIndex = index;

        // Special handling for AOF tables (3 seats)
        // Current user is seated at the bottom middle, with the other two players seated at the top left and top right
        if (this.props.roomState.type === 'aof') {
            const currentPlayer = this.props.roomState.players.find(p => p.userId === this.props.userState.id);
            
            if (currentPlayer && currentPlayer.seatIndex !== null && currentPlayer.seatIndex !== undefined) {
                const currentUserSeatIndex = currentPlayer.seatIndex;

                // Current user at position 2, swap seat 2 with current user's original position
                const playerAtSeat2 = this.props.roomState.players.find(p => p.seatIndex === 2);
                
                if (index === currentUserSeatIndex) {
                    // This is the current player's slot - show at position 2 (bottom middle)
                    adjustedSeatIndex = 2;
                } else if (index === 2) {
                    // This is seat 2 - swap with current user's original position
                    if (playerAtSeat2 && playerAtSeat2.userId !== this.props.userState.id) {
                        // Someone else was at seat 2 - swap them to current user's original position
                        adjustedSeatIndex = currentUserSeatIndex;
                    } else {
                        // Seat 2 was empty - the empty slot moves to current user's original position
                        adjustedSeatIndex = currentUserSeatIndex;
                    }
                } else {
                    // Everyone else stays where they are
                    adjustedSeatIndex = index;
                }
            } else {
                // No adjustment needed when current user is not seated
                adjustedSeatIndex = index;
            }
        } else {
            // Original logic for non-AOF tables
            if (isCurrentUserSeatedAnywhere) {
                const currentUser = this.props.roomState.players.find(p => p.userId === this.props.userState.id);
                const currentUserSeatIndex = currentUser!.seatIndex;
                if (currentUserSeatIndex !== null) {
                    const targetSeat = isMobile ? 3 : 4;
                    const shift = (targetSeat - currentUserSeatIndex + 6) % 6;
                    adjustedSeatIndex = (index + shift) % 6;
                }
            }
        }

        const shouldShowCards = shouldShowPlayerCardsForRoomState(
            this.props.roomState.type,
            this.props.roomState.stateName,
            this.state.playerCardsVisible
        );
        const currentShowdownRevealKey = `${this.props.roomState.roomId}:${this.props.roomState.gameId}:${this.props.roomState.handId}`;
        const revealedShowdownCards = this.state.playerCardsVisible && this.state.showdownCardsRevealKey === currentShowdownRevealKey
            ? (this.props.roomState.showdownCards || [])
            : [];

        return (
            <PlayerSlot
                key={`player-slot-${index}`}
                index={index}
                player={player || null}
                isCurrentUserSeatedAnywhere={isCurrentUserSeatedAnywhere}
                adjustedSeatIndex={adjustedSeatIndex}
                isDealer={player?.userId === this.props.roomState.dealerId || false}
                isBigBlind={player?.userId === this.props.roomState.bigBlindId || false}
                isSmallBlind={player?.userId === this.props.roomState.smallBlindId || false}
                isActiveGameRound={ACTIVE_GAME_ROUNDS.includes(this.props.roomState.stateName || '')}
                actionBadge={this.state.actionBadges[player?.userId || '']}
                winnerIndicator={this.state.winnerIndicators[player?.userId || '']}
                isClientPlayer={player?.userId === this.props.userState.id || false}
                shouldShowCards={shouldShowCards}
                isPlayerTurn={player?.userId === this.props.roomState.activePlayerId || false}
                balanceChanges={this.state.balanceChanges}
                formatCurrency={this.formatCurrency}
                handleSitButtonClick={this.handleSitButtonClick}
                getSlotPosition={this.getSlotPosition}
                getSlotClassName={this.getSlotClassName}
                getPlayerButtonPosition={this.getPlayerButtonPosition}
                getPlayerInfoStyles={this.getPlayerInfoStyles}
                getVisibleCardPosition={this.getVisibleCardPosition}
                getShowdownCardPosition={this.getShowdownCardPosition}
                getCardPosition={this.getCardPosition}
                getChipPosition={this.getChipPosition}
                getActionPosition={this.getActionPosition}
                activePlayerTimer={this.state.activePlayerTimer}
                turnStartTime={this.props.roomState.currentTurnStartTime || ''}
                turnTime={this.props.roomState.turnTime}
                emptyIcon={emptyIcon}
                sitHereIcon={sitHereIcon}
                userId={this.props.userState.id}
                cardAnimationStyle={PlayerCardAnimationStyle.DEAL}
                showdownCards={revealedShowdownCards.map((sc: any) => ({
                    username: sc.username || (this.props.roomState.players.find(p => p.userId === sc.userId)?.username || ''),
                    show: sc.show,
                    cards: sc.cards
                }))}
                stateName={this.props.roomState.stateName || ''}
                type={this.props.roomState.type || ''}
                pendingBalanceUpdates={this.props.roomState.pendingBalanceUpdates || []}
                playerEquities={this.props.roomState.playerEquities}
                currencyType={this.getDisplayCurrencyType()}
                currency={this.getDisplayCurrency()}
                hideCurrentBetChipsThisHand={this.state.hideCurrentBetChipsThisHand}
                isTournamentTable={this.props.roomState.isTournamentTable}
                isHandPresentationFadingOut={this.state.completedHandPresentationFadingOut}
                canOpenTableReactionPicker={this.canOpenTableReactionPickerForPlayer(player)}
                onOpenTableReactionPicker={this.handleOpenTableReactionPicker}
            />
        );
    };

    getTheme(themeName: string): PokerTheme {
        switch (themeName) {
            case 'modern':
                return modernTheme;
            case 'luxury':
                return luxuryTheme;
            case 'western':
                return westernTheme;
            case 'space':
                return spaceTheme;
            default:
                return classicTheme;
        }
    }

    changeTheme = (newTheme: 'classic' | 'modern' | 'luxury' | 'western' | 'space') => {
        this.setState({
            currentTheme: this.getTheme(newTheme)
        });
    }

    getPlayerInfo() {
        const players = Array.isArray(this.props.roomState.players) ? this.props.roomState.players : [];
        return this.getPlayerInfoMemo(players, this.props.userState.id, this.props.roomState.activePlayerId);
    }

    getTableSeatCount = () => {
        return this.props.roomState.type === 'aof'
            ? AOF_TABLE_SEAT_COUNT
            : TEXAS_TABLE_SEAT_COUNT;
    };

    getDisplayData() {
        const winnersToDisplay = this.state.isPinned ? this.state.pinnedWinners : this.props.roomState.winners;
        const communityCardsToDisplay = this.state.isPinned ? this.state.pinnedCommunityCards : this.state.visibleCommunityCards;
        const playersToDisplay = this.state.isPinned ? this.state.pinnedPlayers : this.props.roomState.players;
        const playerTurnHistoryToDisplay = this.state.isPinned
            ? this.state.pinnedPlayerTurnHistory
            : this.memoizedPlayerTurnHistory;
        const nonWinnersToDisplay = this.state.isPinned
            ? this.state.pinnedNonWinners
            : (this.props.roomState.nonWinners || []);
        const gameIdToDisplay = this.state.isPinned ? this.state.pinnedGameId : this.props.roomState.gameId;

        return {
            winnersToDisplay,
            communityCardsToDisplay,
            playersToDisplay,
            playerTurnHistoryToDisplay,
            nonWinnersToDisplay,
            gameIdToDisplay
        };
    }

    handleRejoinButtonClick = () => {
        if (this.props.roomState.roomId) {
            this.props.sendAction(this.props.roomState.roomId, 'rejoinNextHand', 0, this.props.userState.id);
            playAudio('click.mp3');
        }
    };

    handleSitBackInClick = () => {
        if (this.props.roomState.roomId && this.props.requestSitBackIn) {
            this.props.requestSitBackIn(this.props.roomState.roomId);
            playAudio('click.mp3');
        }
    };

    private handleAddBalanceClick = () => {
        const currentPlayer = this.props.roomState.players.find(p => p.userId === this.props.userState.id);
        if (currentPlayer) {
            this.props.requestBalanceOptions(this.props.roomState.roomId, this.props.userState.id);
        }
    };

    private shouldShowTopUpOptions = () => {
        const currentPlayer = this.props.roomState.players.find(p =>
            p.userId === this.props.userState.id &&
            p.seatIndex !== null
        );
        return !!currentPlayer;
    };

    handleAutoActionSelect = (action: string | null, maxCallAmount?: number) => {
        if (!action) {
            this.props.requestCancelAutoAction(this.props.roomState.roomId);
            return;
        }

        const intent = this.getAutoActionIntent(action);
        if (!intent) return;

        if (this.state.selectedAutoAction?.type === intent) {
            this.props.requestCancelAutoAction(this.props.roomState.roomId);
            return;
        }

        this.props.requestSetAutoAction(this.props.roomState.roomId, intent, maxCallAmount);
    };

    private getAutoActionIntent = (action: string): AutoActionIntent | null => {
        switch (action) {
            case 'check':
            case 'check-or-fold':
                return 'checkOrFold';
            case 'fold':
                return this.getPreActionFoldLabel() === 'Check/Fold' ? 'checkOrFold' : 'fold';
            case 'call':
                return 'call';
            case 'call-any':
                return 'callAny';
            case 'all-in':
            case 'allIn':
                return 'allIn';
            default:
                return null;
        }
    };

    private getPreActionFoldLabel = (): string | undefined => {
        const currentPlayer = this.props.roomState.players.find(p => p.userId === this.props.userState.id);
        if (this.props.roomState.type !== 'texas' || !currentPlayer) return undefined;

        return Math.max(0, (this.props.roomState.currentBet || 0) - (currentPlayer.currentBet || 0)) === 0
            ? 'Check/Fold'
            : 'Fold';
    };

    isAutoActionsEnabled = (): boolean => {
        const currentPlayer = this.props.roomState.players.find(p => p.userId === this.props.userState.id);
        const roomType = this.props.roomState.type;

        if (roomType === 'aof') {
            const hasPotentialActions = currentPlayer &&
                currentPlayer.potentialActions &&
                currentPlayer.potentialActions.length > 0;
            return !!(
                this.props.roomState.stateName === 'dealing' &&
                this.props.roomState.activePlayerId !== this.props.userState.id &&
                currentPlayer &&
                !currentPlayer.hasFoldedInCurrentGame &&
                !currentPlayer.hasActedThisRound &&
                !currentPlayer.hasActed &&
                hasPotentialActions
            );
        } else if (roomType === 'texas') {
            const isBettingRound = ['dealing', 'preFlop', 'flop', 'turn', 'river'].includes(this.props.roomState.stateName || '');
            const hasPotentialActions = currentPlayer && 
                currentPlayer.potentialActions && 
                currentPlayer.potentialActions.length > 0;
            return !!(
                isBettingRound &&
                this.props.roomState.activePlayerId !== this.props.userState.id &&
                currentPlayer &&
                !currentPlayer.hasFoldedInCurrentGame &&
                !currentPlayer.hasActedThisRound &&
                hasPotentialActions
            );
        }
        
        return false;
    };

    private handleTopUpOptionChange = (type: 'next' | 'all' | 'cancel', playerId: string) => {
        switch (type) {
            case 'next':
                this.props.requestTopUpNextHand(this.props.roomState.roomId);
                break;
            case 'all':
                this.props.requestTopUpAlways(this.props.roomState.roomId);
                break;
            case 'cancel':
                this.props.requestCancelTopUp(this.props.roomState.roomId);
                break;
        }
    };

    getChipIcon = () => {
        const { currencyType } = this.props.roomState;
        if (currencyType === 'crypto') {
            return fundsChipIcon;
        }
        return stakesChipIcon;
    }

    handleCopyClick = (textToCopy: string) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy).then(() => {
                this.setState({ copySuccess: 'Copied!' });
                setTimeout(() => this.setState({ copySuccess: null }), 1500);
            }).catch(() => {
                this.setState({ copySuccess: 'Copy error' });
                setTimeout(() => this.setState({ copySuccess: null }), 1500);
            });
            return;
        }

        this.setState({ copySuccess: 'Copy unavailable' });
        setTimeout(() => this.setState({ copySuccess: null }), 1500);
    };

    private handleAudioPresetMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ audioPresetMenuAnchorEl: event.currentTarget });
    };

    private handleAudioPresetMenuClose = () => {
        this.setState({ audioPresetMenuAnchorEl: null });
    };

    private handleAudioPresetSelect = (presetId: PokerAudioPresetId) => {
        const selectedAudioPresetId = this.audioPresetManager.setSelectedPresetId(presetId);
        this.setState({
            selectedAudioPresetId,
            audioPresetMenuAnchorEl: null
        });
    };

    private handleAudioMuteToggle = () => {
        this.setState((prevState) => {
            if (prevState.isAudioMuted) {
                const restoredVolume = prevState.audioVolumeBeforeMute ?? 0.7;
                setMuted(false);
                setVolume(restoredVolume);
                return {
                    isAudioMuted: false,
                    audioVolumeBeforeMute: null
                };
            }

            const currentVolume = getVolume();
            setMuted(true);
            setVolume(0);
            return {
                isAudioMuted: true,
                audioVolumeBeforeMute: currentVolume > 0 ? currentVolume : prevState.audioVolumeBeforeMute
            };
        });
    };

    private renderAudioMuteToggle = () => (
        <Tooltip title={this.state.isAudioMuted ? 'Unmute sound' : 'Mute sound'}>
            <IconButton
                className={isMobile ? styles.mobileHeaderIcon : styles.headerIcon}
                aria-label={this.state.isAudioMuted ? 'Unmute sound' : 'Mute sound'}
                aria-pressed={this.state.isAudioMuted}
                onClick={this.handleAudioMuteToggle}
            >
                {this.state.isAudioMuted ? <VolumeOff /> : <VolumeUp />}
            </IconButton>
        </Tooltip>
    );

    private renderAudioPresetSelector = (targetDocument: Document) => {
        const selectedPreset = this.audioPresetManager.getPreset(this.state.selectedAudioPresetId);
        const presets = this.audioPresetManager.getPresets();

        return (
            <>
                <Tooltip title={`Audio preset: ${selectedPreset.label}`}>
                    <IconButton
                        className={isMobile ? styles.mobileHeaderIcon : styles.headerIcon}
                        aria-label="Audio preset"
                        aria-haspopup="menu"
                        aria-expanded={Boolean(this.state.audioPresetMenuAnchorEl)}
                        onClick={this.handleAudioPresetMenuOpen}
                    >
                        <Settings />
                    </IconButton>
                </Tooltip>
                <Menu
                    anchorEl={this.state.audioPresetMenuAnchorEl}
                    open={Boolean(this.state.audioPresetMenuAnchorEl)}
                    onClose={this.handleAudioPresetMenuClose}
                    container={targetDocument.body}
                    PaperProps={{
                        sx: {
                            minWidth: 250,
                            backgroundColor: '#191824',
                            border: '1px solid rgba(255,255,255,0.12)',
                            color: '#f4f5f7'
                        }
                    }}
                >
                    {presets.map((preset) => {
                        const isSelected = preset.id === this.state.selectedAudioPresetId;
                        return (
                            <MenuItem
                                key={preset.id}
                                selected={isSelected}
                                onClick={() => this.handleAudioPresetSelect(preset.id)}
                                sx={{
                                    alignItems: 'center',
                                    gap: 1,
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(255,255,255,0.10)'
                                    },
                                    '&.Mui-selected:hover': {
                                        backgroundColor: 'rgba(255,255,255,0.14)'
                                    }
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 28, color: isSelected ? '#ffffff' : '#8e99aa' }}>
                                    {isSelected ? <Check fontSize="small" /> : <VolumeUp fontSize="small" />}
                                </ListItemIcon>
                                <ListItemText
                                    primary={preset.label}
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                />
                            </MenuItem>
                        );
                    })}
                </Menu>
            </>
        );
    };

    private renderTableReactionVisibilityToggle = () => (
        <Tooltip title={this.state.showTableReactions ? 'Hide throwables' : 'Show throwables'}>
            <IconButton
                className={isMobile ? styles.mobileHeaderIcon : styles.headerIcon}
                aria-label={this.state.showTableReactions ? 'Hide throwables' : 'Show throwables'}
                aria-pressed={!this.state.showTableReactions}
                onClick={this.handleToggleTableReactions}
            >
                {this.state.showTableReactions ? <Visibility /> : <VisibilityOff />}
            </IconButton>
        </Tooltip>
    );

    private handleSitOutBbOptionChange = (isSitOut: boolean) => {
        if (isSitOut) {
            this.props.requestSitOutNextBb(this.props.roomState.roomId);
        } else {
            this.props.requestCancelSitOutNextBb(this.props.roomState.roomId);
        }
    };

    render() {
        if (!this.props.roomState || !this.props.roomState.initialized) {
            return <Typography>Loading room state...</Typography>;
        }

        const { players, currentPlayer, isCurrentPlayerTurn, foldedPlayers } = this.getPlayerInfo();
        const { winnersToDisplay, communityCardsToDisplay, playersToDisplay, playerTurnHistoryToDisplay, nonWinnersToDisplay, gameIdToDisplay } = this.getDisplayData();

        // Get the correct document to render dialogs
        const targetDocument = this.context ? this.context.document : document;
        const isTournamentEliminated = Boolean(this.props.roomState.tournamentEliminated) || Boolean(this.props.roomState.tournamentEliminationTime);
        const cannotLeaveTournamentYet = this.props.roomState.isTournamentTable && this.props.isUserSeated && !isTournamentEliminated;

        return (
            <ThemeProvider theme={this.state.currentTheme}>
                <Box className={`${styles.tableWindow}${this.props.roomState.isFinalTournamentTable ? ` ${styles.finalTournament}` : this.props.roomState.isTournamentTable ? ` ${styles.tournament}` : ''}`}>
                    <Box className={`${isMobile ? styles.mobileTableContainer : styles.tableContainer}${this.props.roomState.isFinalTournamentTable ? ` ${styles.finalTournament}` : this.props.roomState.isTournamentTable ? ` ${styles.tournament}` : ''}`}>
                        {/* Status bar */}
                        {!isMobile && (
                            <StatusBar
                                stateName={this.props.roomState.stateName}
                                pot={this.props.roomState.pot}
                                playerEquities={this.props.roomState.playerEquities || {}}
                                players={this.props.roomState.players}
                                sidePots={this.props.roomState.sidePots}
                                formatCurrency={this.formatCurrency}
                                gameStartingIn={this.props.roomState.gameStartingIn}
                                isTableClosed={this.props.roomState.isTableClosed}
                                isTournamentStarting={this.props.roomState.isTournamentStarting}
                                tableReactionStatus={this.state.tableReactionStatus}
                            />
                        )}

                        {/* Header */}
                        {isMobile && (
                            <>
                                <Drawer
                                    className={styles.mobileDrawer}
                                    anchor="top"
                                    open={this.state.isMobileDrawerExpanded}
                                    onClose={() => this.setState({ isMobileDrawerExpanded: !this.state.isMobileDrawerExpanded })}
                                    PaperProps={{ sx: { backgroundColor: '#191824' } }}
                                >
                                    <List>
                                        <ListItem disablePadding onClick={() => this.setState({ isMobileDrawerExpanded: !this.state.isMobileDrawerExpanded })}>
                                            <ListItemButton>
                                                <ListItemIcon sx={{ minWidth: '36px', color: '#8695a6' }}>
                                                    <MenuIcon />
                                                </ListItemIcon>
                                            </ListItemButton>
                                        </ListItem>
                                        {this.props.roomState.isTournamentTable && (
                                            <ListItem disablePadding onClick={this.handleTournamentLobbyClick}>
                                                <ListItemButton>
                                                    <ListItemIcon sx={{ minWidth: '36px', color: '#8695a6' }}>
                                                        <ViewColumnIcon />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={t('GameRoom:menu.openTournamentLobby')}
                                                        primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 600 } }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {/* <ListItem disablePadding onClick={this.handleAddBalanceClick}>
                                            <ListItemButton disabled={!this.props.isUserSeated}>
                                                <ListItemIcon sx={{ minWidth: '36px', color: '#8695a6' }}>
                                                    <AddCardIcon />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary="Add Funds"
                                                    primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 600 } }}
                                                />
                                            </ListItemButton>
                                        </ListItem> */}
                                        {/* <ListItem disablePadding onClick={() => this.setState({ showDebugPanel: !this.state.showDebugPanel })}>
                                            <ListItemButton>
                                                <ListItemIcon sx={{ minWidth: '36px', color: '#8695a6' }}>
                                                    <BugReportIcon />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary="Debug Info"
                                                    primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 600 } }}
                                                />
                                            </ListItemButton>
                                        </ListItem> */}
                                        <ListItem disablePadding onClick={this.handleSwitchToLobby}>
                                            <ListItemButton disabled={this.props.isDetached}>
                                                <ListItemIcon sx={{ minWidth: '36px', color: '#8695a6' }}>
                                                    <Apps />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={t('GameRoom:menu.goToLobby')}
                                                    primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 600 } }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem
                                            disablePadding
                                            onClick={() => this.props.updateRoomState({
                                                roomId: this.props.roomState.roomId,
                                                state: { showLeaveSeatDialog: true }
                                            })}
                                        >
                                            <ListItemButton disabled={!this.props.isUserSeated || this.props.roomState.isTournamentTable}>
                                                <ListItemIcon sx={{ minWidth: '36px', color: '#8695a6' }}>
                                                    <EventSeat />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={this.props.roomState.isTournamentTable
                                                        ? t('GameRoom:tooltips.cantStandUpTournament')
                                                        : t('GameRoom:tooltips.standUp')}
                                                    primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 600 } }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem
                                            disablePadding
                                            onClick={() => {
                                                if (!this.props.roomState.isTournamentTable) {
                                                    if (this.props.isUserSeated) {
                                                        this.props.updateRoomState({
                                                            roomId: this.props.roomState.roomId,
                                                            state: { showLeaveRoomDialog: true }
                                                        });
                                                    } else {
                                                        this.handleLeaveRoom();
                                                    }
                                                } else {
                                                    if (!this.props.isUserSeated || isTournamentEliminated) {
                                                        this.handleLeaveRoom();
                                                    }
                                                }
                                            }}
                                        >
                                            <ListItemButton disabled={cannotLeaveTournamentYet}>
                                                <ListItemIcon sx={{ minWidth: '36px', color: '#8695a6' }}>
                                                    <LeaveRoomIcon />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={cannotLeaveTournamentYet
                                                        ? t('GameRoom:tooltips.cantLeaveTournament')
                                                        : t('GameRoom:tooltips.leaveTable')}
                                                    primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 600 } }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        {currentPlayer && this.shouldShowTopUpOptions() && !currentPlayer.isSitOut && !currentPlayer.isTournamentSitOut && !this.props.roomState.isTournamentTable && (
                                            <Box sx={{ padding: '8px 16px' }}>
                                                <Divider sx={{ marginBottom: '8px' }} />
                                                <AutoActionOptionsComponent
                                                    selectedAutoAction={this.state.selectedAutoAction?.type ?? null}
                                                    onAutoActionChange={this.handleAutoActionSelect}
                                                    isEnabled={this.isAutoActionsEnabled()}
                                                    type={this.props.roomState.type}
                                                    potentialActions={currentPlayer.potentialActions}
                                                    smallBlind={this.props.roomState.smallBlind}
                                                    preActionFoldLabel={this.getPreActionFoldLabel()}
                                                    formatCurrency={this.formatCurrency}
                                                    currencyType={this.getDisplayCurrencyType()}
                                                />
                                                <SitOutOptionsComponent
                                                    playerId={currentPlayer.userId}
                                                    willSitOutNextHandPlayers={this.ensureWillSitOutArray(this.props.roomState.willSitOutNextHandPlayers)}
                                                    onSitOutOptionChange={(isSitOut) => {
                                                        if (isSitOut) {
                                                            this.props.requestSitOutNextHand(this.props.roomState.roomId);
                                                        } else {
                                                            this.props.requestCancelSitOutNextHand(this.props.roomState.roomId);
                                                        }
                                                    }}
                                                    isSatOut={currentPlayer.isSitOut}
                                                    roomType={this.props.roomState.type || ''}
                                                    willSitOutNextBbPlayers={this.props.roomState.willSitOutNextBbPlayers || []}
                                                    onSitOutBbOptionChange={this.handleSitOutBbOptionChange}
                                                />
                                                {/* <TopUpOptionsComponent
                                                    playerId={currentPlayer.userId}
                                                    topUpNextHandPlayers={this.props.roomState.topUpNextHandPlayers || []}
                                                    topUpAllHandsPlayers={this.props.roomState.topUpAllHandsPlayers || []}
                                                    onTopUpOptionChange={this.handleTopUpOptionChange}
                                                    isSatOut={currentPlayer.isSitOut}
                                                    willSitOutNextHand={this.ensureWillSitOutArray(this.props.roomState.willSitOutNextHandPlayers).includes(currentPlayer.userId)}
                                                /> */}
                                            </Box>
                                        )}
                                    </List>
                                </Drawer>
                                <Stack direction="row" alignItems="center" justifyContent="space-between" className={styles.mobileTableHeader}>
                                    <IconButton className={styles.mobileHeaderIcon} onClick={() => this.setState({ isMobileDrawerExpanded: !this.state.isMobileDrawerExpanded })} sx={{ position: 'absolute', top: '16px', left: '8px' }}>
                                        <MenuIcon />
                                    </IconButton>
                                    <Stack direction="row" alignItems="center" className={styles.mobileHeaderActions}>
                                        {this.renderTableReactionVisibilityToggle()}
                                        {this.renderAudioMuteToggle()}
                                        {this.renderAudioPresetSelector(targetDocument)}
                                    </Stack>
                                </Stack>
                            </>
                        )}
                        {!isMobile && (
                            <Stack direction="row" alignItems="center" justifyContent="flex-end" className={styles.tableHeader}>
                                {this.props.roomState.isPausedForTableOperation && (
                                    <Tooltip title={t('GameRoom:tooltips.tablePaused')}>
                                        <Pause
                                            sx={{
                                                color: '#9FA0A7',
                                                opacity: 0.4,
                                                mr: 1,
                                                fontSize: '1.5rem',
                                                '@keyframes pulse': {
                                                    '0%': { transform: 'scale(0.9)', opacity: 0.4 },
                                                    '50%': { transform: 'scale(1)', opacity: 0.8 },
                                                    '100%': { transform: 'scale(0.9)', opacity: 0.4 },
                                                },
                                                animation: 'pulse 1.4s ease-in-out infinite'
                                            }}
                                        />
                                    </Tooltip>
                                )}
                                {/* <Tooltip title="Debug Info">
                                    <IconButton
                                        className={styles.headerIcon}
                                        onClick={() => this.setState({ showDebugPanel: !this.state.showDebugPanel })}
                                    >
                                        <BugReportIcon />
                                    </IconButton>
                                </Tooltip> */}
                                {this.props.roomState.isTournamentTable && (
                                    <Tooltip title={t('GameRoom:menu.openTournamentLobby')}>
                                        <IconButton className={styles.headerIcon} sx={{}} onClick={this.handleTournamentLobbyClick}>
                                            <ViewColumnIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip title={this.props.roomState.isTournamentTable
                                    ? t('GameRoom:tooltips.cantStandUpTournament')
                                    : t('GameRoom:tooltips.standUp')}>
                                    <span>
                                        <IconButton className={styles.headerIcon} onClick={() => this.props.updateRoomState({
                                            roomId: this.props.roomState.roomId,
                                            state: { showLeaveSeatDialog: true }
                                        })} disabled={!this.props.isUserSeated || this.props.roomState.isTournamentTable}>
                                            <FileUploadIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                {/* <Tooltip title="Add funds">
                                    <span>
                                        <IconButton
                                            className={styles.headerIcon}
                                            onClick={this.handleAddBalanceClick}
                                            disabled={!this.props.isUserSeated}
                                        >
                                            <AddCardIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip> */}
                                <Tooltip title={cannotLeaveTournamentYet
                                    ? t('GameRoom:tooltips.cantLeaveTournament')
                                    : t('GameRoom:tooltips.leaveTable')}>
                                    <span>
                                        <IconButton
                                            className={styles.headerIcon}
                                            aria-label="close"
                                            disabled={cannotLeaveTournamentYet}
                                            onClick={() => {
                                                if (!this.props.roomState.isTournamentTable) {
                                                    if (this.props.isUserSeated) {
                                                        this.props.updateRoomState({
                                                            roomId: this.props.roomState.roomId,
                                                            state: { showLeaveRoomDialog: true }
                                                        });
                                                    } else {
                                                        this.handleLeaveRoom();
                                                    }
                                                } else {
                                                    if (!this.props.isUserSeated || isTournamentEliminated) {
                                                        this.handleLeaveRoom();
                                                    }
                                                }
                                            }}
                                        >
                                            <LeaveRoomIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                {/* <Tooltip title="Go to Lobby">
                                    <span>
                                        <IconButton className={styles.headerIcon} aria-label="close" onClick={this.handleSwitchToLobby} disabled={this.props.isDetached}>
                                            <SwitchToLobbyIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip> */}
                                {this.renderTableReactionVisibilityToggle()}
                                {this.renderAudioPresetSelector(targetDocument)}
                            </Stack>
                        )}

                        {/* Poker Table */}
                        <Box sx={{
                            paddingBlock: isMobile ? 0 : POKER_TABLE_DESKTOP_SURFACE_LAYOUT.paddingBlock,
                            paddingInline: isMobile ? 0 : POKER_TABLE_DESKTOP_SURFACE_LAYOUT.paddingInline,
                            position: 'relative',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: isMobile ? 'calc(100% - 173px)' : `calc(100% - ${POKER_TABLE_DESKTOP_SURFACE_LAYOUT.heightOffset})`,
                            marginTop: isMobile ? '76px' : POKER_TABLE_DESKTOP_SURFACE_LAYOUT.marginTop,
                            width: '100%',
                            boxSizing: 'border-box',
                        }}>
                            <Stack className={styles.roomGames} direction="row" spacing={2} sx={{ display: { xs: 'none', md: 'flex' } }}>
                                <Link href="" target="_blank" className={styles.gameLink} sx={{ display: { lg: 'block', xs: 'none' } }} title="Link to your website here">
                                    <img src={blackjackIcon} alt="Blackjack Icon" />
                                </Link>
                                <Link href="" target="_blank" className={styles.gameLink} sx={{ display: { lg: 'block', xs: 'none' } }} title="Link to your website here">
                                    <img src={baccaratIcon} alt="Baccarat Icon" />
                                </Link>
                                <Link href="" target="_blank" className={styles.gameLink} sx={{ display: { lg: 'block', xs: 'none' } }} title="Link to your website here">
                                    <img src={rouletteIcon} alt="Roulette Icon" />
                                </Link>
                            </Stack>
                            
                            {this.props.roomState.type === 'aof' ? (
                                <Stack className={styles.roomInfo} sx={{ display: { xs: 'none', md: 'flex' } }}>
                                    <Typography className={styles.roomTitle}>
                                        {this.props.roomState.name || 'N/A'}
                                        {this.props.roomState.isFinalTournamentTable ? ' (FINAL)' : ''}
                                    </Typography>
                                    <Typography className={styles.roomStakes}>
                                        <img src={this.getChipIcon()} alt="PokerSolutions Chip Icon" height={16} style={{ marginRight: '5px' }} />
                                        Ante: {this.formatCurrency(this.props.roomState.ante)} - Buy In: {this.formatCurrency(this.props.roomState.maxBuyIn)}
                                    </Typography>
                                </Stack>
                            ) : (
                                <Stack className={styles.roomInfo} sx={{ display: { xs: 'none', md: 'flex' } }}>
                                    <Typography className={styles.roomTitle}>
                                        {this.props.roomState.name || 'N/A'}
                                        {this.props.roomState.isFinalTournamentTable ? ' (FINAL)' : ''}
                                    </Typography>

                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, zIndex: 2 }}>
                                        <Typography 
                                            className={styles.roomTitle} 
                                            sx={{ 
                                                userSelect: 'text', 
                                                display: 'inline',
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={() => this.setState({ showFullGameId: true })}
                                            onMouseLeave={() => this.setState({ showFullGameId: false })}
                                        >
                                            {this.props.roomState.gameId_ ? 
                                                `Game ID: ${this.state.showFullGameId || this.props.roomState.gameId_.length <= 4 ? 
                                                    this.props.roomState.gameId_ : 
                                                    `${this.props.roomState.gameId_.substring(0, 4)}...`}`
                                                : ''
                                            }
                                        </Typography>
                                        {this.props.roomState.gameId_ && !this.props.isDetached && (
                                            <Tooltip title={this.state.copySuccess ? t('GameRoom:tooltips.copied') : t('GameRoom:tooltips.copyGameId')} placement="top">
                                                <span> {/* Span needed for tooltip when button is disabled */} 
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => this.handleCopyClick(this.props.roomState.gameId_ || '')}
                                                        sx={{ padding: '2px', color: 'inherit' }}
                                                    >
                                                        <ContentCopyIcon fontSize="inherit" />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        )}
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, position: 'relative' }}>
                                        <Typography className={styles.roomStakes}><img src={stakesChipIcon} alt="PokerSolutions Chip Icon" height={16} style={{ marginRight: '5px' }} /> {this.formatCurrency(this.props.roomState.smallBlind)} / {this.formatCurrency(this.props.roomState.bigBlind)}</Typography>
                                        {this.props.roomState.isTournamentTable && this.props.roomState.tournamentExtraInformation && (
                                            <>
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.setState({ showTournamentExtraInfo: !this.state.showTournamentExtraInfo });
                                                    }}
                                                    sx={{
                                                        color: 'rgba(255,255,255,0.4)',
                                                        padding: '2px',
                                                        minWidth: '18px',
                                                        minHeight: '18px',
                                                        marginLeft: '3px',
                                                        '&:hover': {
                                                            color: 'rgba(255,255,255,0.7)',
                                                            backgroundColor: 'rgba(255,255,255,0.08)'
                                                        }
                                                    }}
                                                >
                                                    <InfoIcon sx={{ fontSize: '16px' }} />
                                                </IconButton>
                                                {this.state.showTournamentExtraInfo && (
                                                    <TournamentExtraInfo
                                                        tournamentExtraInformation={this.props.roomState.tournamentExtraInformation}
                                                        onClose={() => this.setState({ showTournamentExtraInfo: false })}
                                                        hasStarted
                                                        prizePool={this.props.roomState.prizePool}
                                                        guaranteedPrizePool={this.props.roomState.guaranteedPrizePool}
                                                    />
                                                )}
                                            </>
                                        )}
                                    </Box>
                                </Stack>
                            )}

                            {/* <Typography style={{ position: "absolute", top: 0, right: "16px" }}>Hand ID: {this.props.roomState.stateName}</Typography> */}
                            <PokerTable
                                pot={this.props.roomState.pot || 0}
                                communityCards={communityCardsToDisplay || []}
                                showAnimatedChip={this.state.showAnimatedChip}
                                formatCurrency={this.formatCurrency}
                                renderCardImage={this.renderCardImage}
                                foldedPlayers={foldedPlayers}
                                theme={this.state.currentTheme}
                                cardAnimationStyle={CardAnimationStyle.FLIP}
                                animatedCommunityCardDelaysMs={this.state.animatedCommunityCardDelaysMs}
                                type={this.props.roomState.type}
                                stateName={this.props.roomState.stateName || ''}
                                currencyType={this.getDisplayCurrencyType()}
                                currency={this.getDisplayCurrency()}
                                stakeLevel={this.getStakeLevel()}
                                players={this.props.roomState.players}
                                visiblePot={this.props.roomState.visiblePot}
                                sidePots={this.props.roomState.visibleSidePots}
                                eligiblePotPlayers={this.props.roomState.eligiblePotPlayers}
                                tableName={this.props.roomState.name}
                                ante={this.props.roomState.ante}
                                smallBlind={this.props.roomState.smallBlind}
                                bigBlind={this.props.roomState.bigBlind}
                                isTournamentTable={this.props.roomState.isTournamentTable}
                                isFinalTournamentTable={this.props.roomState.isFinalTournamentTable}
                                isHandPresentationFadingOut={this.state.completedHandPresentationFadingOut}
                            >
                                {Array.from({ length: this.getTableSeatCount() }, (_, index) => this.renderPlayerSlot(index))}
                                <Box
                                    data-poker-table-reaction-overlay-room-id={this.props.roomState.roomId}
                                    sx={{
                                        position: 'absolute',
                                        inset: 0,
                                        overflow: 'visible',
                                        pointerEvents: 'none',
                                        zIndex: 9999
                                    }}
                                >
                                    <PokerTableReactionLayer reactions={this.state.activeTableReactions} />
                                </Box>
                            </PokerTable>

                            {/* Winners Display */}
                            {this.state.isPinned && this.state.lastWinners && (
                                <WinnersDisplay
                                    winners={this.state.lastWinners}
                                    nonWinners={this.state.lastNonWinners}
                                    communityCards={this.state.lastCommunityCards || []}
                                    isPinned={this.state.isPinned}
                                    onPinToggle={this.handlePinToggle}
                                    formatCurrency={this.formatCurrency}
                                    players={this.props.roomState.players}
                                    playerTurnHistory={this.state.lastPlayerTurnHistory}
                                    roomId={this.props.roomState.roomId}
                                    gameId={this.props.roomState.gameId}
                                />
                            )}
                        </Box>

                        {currentPlayer && (
                            <>
                                {/* Turn Action Controls */}
                                <TurnActionControls
                                    gameType={this.props.roomState.type}
                                    isSitOut={currentPlayer.isSitOut}
                                    isTournamentSitOut={Boolean(currentPlayer.isTournamentSitOut)}
                                    sitOutBank={currentPlayer.sitOutBank}
                                    isWaitingForBigBlind={this.ensureWillSitOutArray(this.props.roomState.playersWaitingForBB).includes(currentPlayer.userId)}
                                    isCurrentPlayerTurn={this.props.roomState.activePlayerId === this.props.userState.id}
                                    availableActions={(() => {
                                        // Defensive: suppress action UI when tournament sit-out
                                        if (currentPlayer.isTournamentSitOut) {
                                            return { actions: [] };
                                        }
                                        const isYourTurn = this.props.roomState.activePlayerId === this.props.userState.id;
                                        const serverAvailable = this.props.roomState.availableActions as any;
                                        if (
                                            isYourTurn &&
                                            serverAvailable &&
                                            serverAvailable.userId === this.props.userState.id &&
                                            Array.isArray(serverAvailable.actions)
                                        ) {
                                            return { actions: serverAvailable.actions };
                                        }
                                        return { actions: [] };
                                    })()}
                                    betAmount={this.state.betAmount}
                                    smallBlind={this.props.roomState.smallBlind}
                                    onRejoinClick={currentPlayer.isTournamentSitOut ? this.handleSitBackInClick : this.handleRejoinButtonClick}
                                    onBetAmountChange={this.handleBetAmountChange}
                                    onSendAction={this.sendAction}
                                    formatCurrency={this.formatCurrency}
                                    currencyType={this.getDisplayCurrencyType()}
                                />

                                {/* Pre actions */}
                                {this.shouldShowTopUpOptions() && !currentPlayer.isSitOut && !currentPlayer.isTournamentSitOut && (
                                    <AutoActionOptionsComponent
                                        selectedAutoAction={this.state.selectedAutoAction?.type ?? null}
                                        onAutoActionChange={this.handleAutoActionSelect}
                                        isEnabled={this.isAutoActionsEnabled()}
                                        type={this.props.roomState.type}
                                        potentialActions={currentPlayer.potentialActions}
                                        smallBlind={this.props.roomState.smallBlind}
                                        preActionFoldLabel={this.getPreActionFoldLabel()}
                                        formatCurrency={this.formatCurrency}
                                        currencyType={this.getDisplayCurrencyType()}
                                    />
                                )}

                                {/* Top Up and Sit Out Options */}
                                {this.shouldShowTopUpOptions() && !currentPlayer.isSitOut && !currentPlayer.isTournamentSitOut && !isMobile && !this.props.roomState.isTournamentTable && (
                                    <Box sx={{
                                        position: 'absolute',
                                        bottom: this.state.isGameInfoExpanded ? '370px' : isMobile ? '52px' : '72px',
                                        left: '16px',
                                        boxSizing: 'border-box',
                                        zIndex: 1000,
                                        transition: 'bottom 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                                    }}>
                                        <SitOutOptionsComponent
                                            playerId={currentPlayer.userId}
                                            willSitOutNextHandPlayers={this.ensureWillSitOutArray(this.props.roomState.willSitOutNextHandPlayers)}
                                            onSitOutOptionChange={(isSitOut) => {
                                                if (isSitOut) {
                                                    this.props.requestSitOutNextHand(this.props.roomState.roomId);
                                                } else {
                                                    this.props.requestCancelSitOutNextHand(this.props.roomState.roomId);
                                                }
                                            }}
                                            isSatOut={currentPlayer.isSitOut}
                                            roomType={this.props.roomState.type || ''}
                                            willSitOutNextBbPlayers={this.props.roomState.willSitOutNextBbPlayers || []}
                                            onSitOutBbOptionChange={this.handleSitOutBbOptionChange}
                                        />
                                        <TopUpOptionsComponent
                                            playerId={currentPlayer.userId}
                                            topUpNextHandPlayers={this.props.roomState.topUpNextHandPlayers || []}
                                            topUpAllHandsPlayers={this.props.roomState.topUpAllHandsPlayers || []}
                                            onTopUpOptionChange={this.handleTopUpOptionChange}
                                            isSatOut={currentPlayer.isSitOut}
                                            willSitOutNextHand={this.ensureWillSitOutArray(this.props.roomState.willSitOutNextHandPlayers).includes(currentPlayer.userId)}
                                        />
                                    </Box>
                                )}
                            </>
                        )}

                        {/* Game Info */}
                        {!isMobile && (
                            <GameInfo
                                players={players}
                                pot={this.props.roomState.pot || 0}
                                currentBet={this.props.roomState.currentBet || 0}
                                roundName={this.props.roomState.roundName}
                                activePlayerId={this.props.roomState.activePlayerId}
                                dealerId={this.props.roomState.dealerId}
                                bigBlindId={this.props.roomState.bigBlindId}
                                smallBlindId={this.props.roomState.smallBlindId}
                                formatCurrency={this.formatCurrency}
                                activityMessages={[
                                    ...(this.props.roomState.activityMessages as ActivityMessage[]),
                                    ...this.state.gameplayActivityMessages
                                ]}
                                playerTurnHistory={this.state.gameplayTurnHistory}
                                renderMessageWithCards={this.renderMessageWithCards}
                                onCollapseChange={this.handleGameInfoCollapseChange}
                            />
                        )}
                    </Box>
                </Box>

                <PokerTableReactionPicker
                    anchorEl={this.state.tableReactionPickerTarget?.anchorEl || null}
                    targetUsername={this.state.tableReactionPickerTarget?.username}
                    isSendDisabled={this.isTableReactionSendOnCooldown()}
                    cooldownSecondsRemaining={this.state.tableReactionCooldownSecondsRemaining}
                    container={this.context ? this.context.document.body : null}
                    onClose={this.handleCloseTableReactionPicker}
                    onSelect={this.handleSelectTableReaction}
                />

                {/* Sit Options Modal */}
                {this.props.roomState.showSitOptionsModal && (
                    <BuyinModal
                        open={true}
                        onClose={() => this.props.updateRoomState({
                            roomId: this.props.roomState.roomId,
                            state: {
                                showSitOptionsModal: false,
                                sitOptions: null
                            }
                        })}
                        onConfirm={this.handleSitOptionsConfirm}
                        buyInLimits={this.props.roomState.sitOptions?.buyInLimits || { min: 0, max: 0 }}
                        gameState={this.props.roomState.sitOptions?.gameState || {
                            isGameActive: false,
                            requiresChoice: false
                        }}
                        roomName={this.props.roomState.name}
                        smallBlind={this.props.roomState.smallBlind}
                        bigBlind={this.props.roomState.bigBlind}
                        userBalance={Number(this.props.userState.balance)}
                        type={this.props.roomState.type}
                        ante={this.props.roomState.ante}
                        sitOptions={this.props.roomState.sitOptions || undefined}
                        currency={this.props.roomState.currency}
                        currencyType={this.props.roomState.currencyType}
                        rebuyOfferProp={this.props.roomState.sitOptions?.rebuyOffer || null}
                        addonOfferProp={this.props.roomState.sitOptions?.addonOffer || null}
                        container={this.context ? this.context.document.body : null}
                    />
                )}

                {/* Leave Seat Confirmation Dialog */}
                {this.props.roomState.showLeaveSeatDialog && (
                    <Dialog
                        open={this.props.roomState.showLeaveSeatDialog}
                        onClose={() => this.props.updateRoomState({
                            roomId: this.props.roomState.roomId,
                            state: { showLeaveSeatDialog: false }
                        })}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        container={this.context ? this.context.document.body : null}
                    >
                        <DialogTitle id="alert-dialog-title">{t('GameRoom:dialogs.leaveSeat.title')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">{t('GameRoom:dialogs.leaveSeat.description')}</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.props.updateRoomState({
                                roomId: this.props.roomState.roomId,
                                state: { showLeaveSeatDialog: false }
                            })}>{t('GameRoom:actions.cancel')}</Button>
                            <Button onClick={this.handleStandFromTable} autoFocus>{t('GameRoom:actions.standUp')}</Button>
                        </DialogActions>
                    </Dialog>
                )}

                {/* Leave Room Confirmation Dialog */}
                {this.props.roomState.showLeaveRoomDialog && (
                    <Dialog
                        open={this.props.roomState.showLeaveRoomDialog}
                        onClose={() => this.props.updateRoomState({
                            roomId: this.props.roomState.roomId,
                            state: { showLeaveRoomDialog: false }
                        })}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        container={this.context ? this.context.document.body : null}
                    >
                        <DialogTitle id="alert-dialog-title">{t('GameRoom:dialogs.leaveRoom.title')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">{t('GameRoom:dialogs.leaveRoom.description')}</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.props.updateRoomState({
                                roomId: this.props.roomState.roomId,
                                state: { showLeaveRoomDialog: false }
                            })}>{t('GameRoom:actions.cancel')}</Button>
                            <Button onClick={this.props.confirmLeaveRoom || this.handleLeaveRoom} autoFocus>{t('GameRoom:actions.leaveRoom')}</Button>
                        </DialogActions>
                    </Dialog>
                )}

                {/* Debug Panel */}
                <DebugPanel
                    show={this.state.showDebugPanel}
                    onClose={() => this.setState({ showDebugPanel: false })}
                    roomState={this.props.roomState}
                    currentUsername={this.props.userState.username}
                    isPaused={this.state.isDebugPaused}
                    onPauseToggle={() => this.setState(prev => ({
                        isDebugPaused: !prev.isDebugPaused
                    }))}
                />

                {/* Winners Modal */}
                {/* Win modal disabled */}

                {/* Tournament End Modal (final table) */}
                {this.props.roomState.showTournamentWinModal && (
                    ReactDOM.createPortal(
                        <WinTournamentModal
                            open={Boolean(this.props.roomState.showTournamentWinModal)}
                            winnerInformation={this.props.roomState.tournamentEndedInfo?.winnerInformation}
                            rankingData={this.props.roomState.tournamentEndedInfo?.rankingData}
                            secondsToClose={this.props.roomState.tournamentEndedInfo?.closeLastTableUponWinSeconds}
                            tournamentId={this.props.roomState.tournamentEndedInfo?.tournamentId}
                            formatCurrency={this.formatCurrency}
                            onShowNotification={this.props.onShowNotification}
                            currentUsername={this.props.userState.username}
                            onClose={() => {
                                const closeRoomId = this.props.roomState.roomId;
                                this.props.updateRoomState({
                                    roomId: closeRoomId,
                                    state: { showTournamentWinModal: false }
                                });
                                // Close the room and navigate back to lobby
                                this.props.leaveRoom(closeRoomId);
                                this.props.switchToLobby();
                            }}
                            container={targetDocument.body}
                        />,
                        targetDocument.body
                    )
                )}

                {/* Show Cards Options */}
                {currentPlayer && this.props.roomState.showCardsOptions && (
                    ReactDOM.createPortal(
                        <ShowCardsOptions
                            cards={currentPlayer.cards || []}
                            isMuckEnabled={this.props.roomState.showCardsOptions.isMuckEnabled}
                            onOptionSelect={(selectedCards) => {
                                if (this.props.requestShowCardsOption) {
                                    this.props.requestShowCardsOption(
                                        this.props.roomState.roomId,
                                        selectedCards
                                    );
                                }
                            }}
                        />,
                        targetDocument.body
                    )
                )}

                {/* Tournament Lobby Modal */}
                {this.state.tournamentLobbyModalOpen && (() => {
                    const modalTournament = this.getTournamentData();
                    const interactionHandler = typeof window !== 'undefined' ? (window as any).interactionHandler as InteractionHandler | undefined : undefined;
                    
                    if (!interactionHandler) {
                        console.warn('InteractionHandler not available. Tournament lobby may not function correctly.');
                        return null;
                    }

                    // Use DesktopTournamentLobbyModal on mobile, DetachedTournamentLobby on desktop
                    if (isMobile) {
                        // On mobile, DesktopTournamentLobbyModal returns null if tournament is null
                        // So we need to ensure tournament is found before rendering
                        if (!modalTournament) {
                            return null;
                        }
                        
                        return (
                            <DesktopTournamentLobbyModal
                                open={this.state.tournamentLobbyModalOpen}
                                tournament={modalTournament}
                                userState={this.props.userState}
                                interactionHandler={interactionHandler}
                                onClose={this.handleTournamentLobbyModalClose}
                            />
                        );
                    } else {
                        // On desktop, DetachedTournamentLobby will render even with null tournament
                        return (
                            <DetachedTournamentLobby 
                                title={t('GameRoom:tournament.lobbyFor', { name: modalTournament?.name || 'Tournament' })} 
                                onClose={this.handleTournamentLobbyModalClose}
                            >
                                <TournamentLobbyContent 
                                    tournament={modalTournament} 
                                    userState={this.props.userState} 
                                    interactionHandler={interactionHandler}
                                />
                            </DetachedTournamentLobby>
                        );
                    }
                })()}
            </ThemeProvider>
        );
    }
}

const GameRoom: React.FC<RoomProps> = (props) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    
    return (
        <GameRoomInner 
            {...props} 
            roomEnqueueSnackbar={enqueueSnackbar}
            roomCloseSnackbar={closeSnackbar}
        />
    );
};

export default GameRoom;
